(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-blog-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-blog-filter')) {
    customElements.define(
      'cb-blog-filter',
      class extends HTMLElement {
        connectedCallback() {
          this.chips = [...this.querySelectorAll('[data-filter]')];
          this.items = [...this.querySelectorAll('.cb-blog-index__item')];
          this.featureFirst = this.dataset.featureFirst === 'true';
          this.chips.forEach((chip) =>
            chip.addEventListener('click', (event) => {
              // Neuer Tab / Strg-Klick bleibt normaler Link.
              if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
              event.preventDefault();
              this.apply(chip);
            })
          );
          // Aktiven Chip mobil in den sichtbaren Bereich der Leiste holen.
          this.querySelector('[data-filter][aria-current]')?.scrollIntoView({ block: 'nearest', inline: 'center' });
        }

        apply(chip) {
          const key = chip.dataset.filter;
          let first = true;
          this.items.forEach((item) => {
            const match =
              key === 'all' ||
              (key === 'news' ? item.dataset.group === 'news' : item.dataset.tags.includes(`|${key}|`));
            item.hidden = !match;
            item.classList.toggle('cb-blog-index__item--feature', match && first && this.featureFirst);
            if (match) first = false;
          });
          this.chips.forEach((c) => c.toggleAttribute('aria-current', c === chip));
          if (chip.hasAttribute('aria-current')) chip.setAttribute('aria-current', 'true');
          // Adresse mitziehen, damit Neuladen und Teilen denselben Filter zeigen – ohne Verlaufseintrag.
          history.replaceState(null, '', chip.getAttribute('href'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-kauf-bar"] && !Shopify.designMode) return;
  try {
    
  /* Lesetempo der Laufschrift in Pixeln je Sekunde: bei 14px Schrift wandert
     damit gut ein Wort pro Sekunde durchs Bild. */
  var CB_MARQUEE_SPEED = 40;
  var CB_MARQUEE_MIN = 6;
  var CB_MARQUEE_MAX = 60;
  /* Der Abstand zwischen zwei Kopien der Spur (2rem), siehe `.cb-kauf-bar__mq-copy`. */
  var CB_MARQUEE_GAP = 32;
  var CB_TABLET = 900;

  function cbMarqueeDuration(distance) {
    if (!isFinite(distance) || distance <= 0) return CB_MARQUEE_MIN;
    var seconds = distance / CB_MARQUEE_SPEED;
    var clamped = Math.min(Math.max(seconds, CB_MARQUEE_MIN), CB_MARQUEE_MAX);
    return Math.round(clamped * 10) / 10;
  }

  /* Ein Pixel Spielraum, weil beide Werte aus Layoutmessungen mit
     Nachkommastellen stammen. */
  function cbNeedsMarquee(content, available) {
    if (!isFinite(content) || !isFinite(available)) return false;
    if (content <= 0 || available <= 0) return false;
    return content > available + 1;
  }

  /* Preisformat der Variante: 7.990,00 € (Suffix, de-DE-Tausenderpunkt).
     Gerechnet wird in ganzen Cent — `toLocaleString` scheidet aus, weil die
     Store-Locale „€7.990,00“ liefert. */
  function cbPrice(cents) {
    var n = Math.round(Number(cents) || 0);
    var sign = n < 0 ? '-' : '';
    n = Math.abs(n);
    var euro = Math.floor(n / 100);
    var sub = n % 100;
    var whole = String(euro);
    var out = '';
    while (whole.length > 3) {
      out = '.' + whole.slice(-3) + out;
      whole = whole.slice(0, -3);
    }
    out = whole + out;
    return sign + out + ',' + (sub < 10 ? '0' + sub : String(sub)) + ' €';
  }

  /* Texte der Leiste und des Kauf-Wegs: kommen als JSON aus dem Markup
     (`script[data-cb-kauf-i18n]`, Sprachdateien `cb.kauf.*`). Gelesen wird erst beim
     Gebrauch, weil das gebuendelte Skript vor dem Markup laufen kann. `[title]` und
     `[amount]` sind Platzhalter. */
  function cbKaufT(key) {
    if (!cbKaufT.data) {
      var el = document.querySelector('script[data-cb-kauf-i18n]');
      if (!el) return '';
      try { cbKaufT.data = JSON.parse(el.textContent); } catch (error) { return ''; }
    }
    return cbKaufT.data[key] || '';
  }
  window.CbKaufT = window.CbKaufT || cbKaufT;

  function cbSvg(paths, size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < paths.length; i++) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', paths[i]);
      svg.appendChild(p);
    }
    return svg;
  }

  /* ---------------------------------------------------------------- Kauf-Weg *
   * Eine Funktion, zwei Aufrufer: die Pille dieser Leiste und der Knopf der
   * Bestelluebersicht (`sections/cb-kauf-v5-setup.liquid`). Zwei Kopien liefen beim
   * naechsten Eingriff auseinander — und der Weg ist heikel genug: Erst der normale
   * Warenkorb-Weg des Themes (nur so gehen Add-ons und Eigenschaften mit), dann auf
   * das Ergebnis warten, dann weiterleiten.
   *
   * options = { button, checkout, busyLabel, onReset, notify }
   * `notify(text)` zeigt die Rueckmeldung dort, wo geklickt wurde. Ohne sie
   * braeche der Weg still ab — und ein Knopf, der auf einen Klick nichts tut,
   * ist schlimmer als eine Fehlermeldung.
   * -------------------------------------------------------------------------- */
  (function () {
    if (window.CbKaufCheckout) return;

    var running = false;

    window.CbKaufCheckout = function (options) {
      var opts = options || {};
      var notify = typeof opts.notify === 'function' ? opts.notify : function () {};
      var native = document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
      var form = native ? native.form || (native.closest ? native.closest('form') : null) : null;

      if (!native || !form) {
        notify(cbKaufT('not_ready'));
        return false;
      }
      if (running) {
        notify(cbKaufT('running'));
        return false;
      }

      /* Abgeschickt wird das FORMULAR, nicht der Knopf angeklickt. Der Kaufblock
         traegt per JS `inert` (`CbKaufBar.applyInert`), damit sein „In den
         Warenkorb“ nicht in der Tab-Reihenfolge steht.

         Gemessen (Vorschau-Theme, Chromium): `inert` haelt NUR Benutzer-Eingaben
         auf — Fokus und echte Mausklicks. Ein programmatisches `native.click()`
         laeuft weiterhin durch, `HTMLElement.click()` fuehrt keinen Treffertest
         aus. Der Weg ueber `click()` waere also gangbar; `requestSubmit` ist
         trotzdem der richtige, weil er nicht an dieser Feinheit haengt und den
         Weg benennt, den das Theme ohnehin nimmt.

         `requestSubmit` loest dasselbe `submit`-Ereignis aus, an dem das Theme
         haengt: `blocks/buy-buttons.liquid` traegt `on:submit="/handleSubmit"`
         auf `product-form-component`, und das Ereignis blubbert aus dem
         Formular dorthin hoch (nachgemessen: `submit@form` ->
         `submit@product-form-component` -> `POST /cart/add.js`).
         `assets/product-form.js` baut daraus wie gehabt `new FormData(form)` —
         Add-ons und `properties[Fahrzeug]` gehen also unveraendert mit. Der
         Knopf wird als Absender uebergeben, damit `name="add"` derselbe bleibt.

         Uebersprungen wird dabei `add-to-cart-component.handleClick` — das ist
         allein die Flug-Animation zum Warenkorbsymbol. Bei einem 1x1 px
         geklemmten Knopf hat sie nichts zu zeigen. */
      var submit = function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(native);
        else native.click();
      };

      var component = form.closest('product-form-component');
      if (!component || native.disabled || !form.reportValidity()) {
        notify(cbKaufT('invalid'));
        return false;
      }

      running = true;
      var btn = opts.button || null;
      var label = btn ? btn.getAttribute('data-cb-label') || btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = opts.busyLabel || cbKaufT('busy');
      }

      var submittedDraft = window.CbKaufV5 && window.CbKaufV5.draftSignature ? window.CbKaufV5.draftSignature() : null;
      var done = false;
      var timer = null;
      var onUpdate = function (event) {
        var data = event.detail && event.detail.data;
        if (event.target !== component || !data || data.source !== 'product-form-component') return;
        finish(!data.didError);
      };
      var onError = function (event) {
        if (event.target !== component) return;
        finish(false);
      };
      var finish = function (ok) {
        if (done) return;
        done = true;
        document.removeEventListener('cart:update', onUpdate);
        document.removeEventListener('cart:error', onError);
        if (timer) window.clearTimeout(timer);
        if (ok) {
          if (window.CbConfigDraft) window.CbConfigDraft.clear(submittedDraft);
          running = false;
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (typeof opts.onSuccess === 'function') opts.onSuccess();
          else if (opts.checkout !== false) {
            window.location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout');
          }
          return;
        }
        running = false;
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
        notify(cbKaufT('unconfirmed'));
        if (typeof opts.onReset === 'function') opts.onReset();
      };

      timer = window.setTimeout(function () {
        notify(cbKaufT('slow'));
      }, 20000);

      document.addEventListener('cart:update', onUpdate);
      document.addEventListener('cart:error', onError);
      try { submit(); } catch (error) { finish(false); return false; }
      return true;
    };
  })();

  class CbKaufBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      /* Doppel-Schutz: laege die Section zweimal im Template, gewaenne die
         erste Instanz in der Dokumentreihenfolge. */
      var all = document.querySelectorAll('cb-kauf-bar');
      if (all.length > 1 && all[0] !== this) {
        this.hidden = true;
        return;
      }
      this.dataset.cbInit = '1';

      this.open = false;
      this.state = null;
      this.rendered = null;

      this.panel = this.querySelector('[data-cb-panel]');
      this.panelBody = this.querySelector('[data-cb-panel-body]');
      this.bottom = this.querySelector('[data-cb-bottom]');
      this.toggleBtn = this.querySelector('[data-cb-toggle]');
      this.detailsBtn = this.querySelector('[data-cb-details]');
      this.primaryBtn = this.querySelector('[data-cb-primary]');
      this.totalEl = this.querySelector('[data-cb-total]');
      this.savingsEl = this.querySelector('[data-cb-savings]');
      this.hintEl = this.querySelector('[data-cb-hint]');
      this.taxEl = this.querySelector('[data-cb-tax]');
      this.adviceEl = this.querySelector('[data-cb-advice]');
      this.noticeEl = this.querySelector('[data-cb-notice]');
      this.phoneWrap = this.querySelector('[data-cb-phone-wrap]');
      this.toggleSr = this.querySelector('[data-cb-toggle-sr]');
      this.detailsSr = this.querySelector('[data-cb-details-sr]');

      this.mq = this.querySelector('[data-cb-mq]');
      this.mqTrack = this.querySelector('[data-cb-mq-track]');
      this.mqCopy = this.querySelector('[data-cb-mq-copy]');
      this.mqText = this.querySelector('[data-cb-mq-text]');
      this.mqClone = null;

      this.showSavings = this.dataset.showSavings !== 'false';

      this.bindState();
      this.bindInteractions();
      this.bindMarquee();
      this.bindHeight();
      this.bindScroll();
      this.bindPrimary();
      this.applyHours();
      this.hoursTimer = window.setInterval(() => this.applyHours(), 60000);

      /* Erststand: die Variante stellt `window.CbKauf` spaetestens beim ersten
         `cb:config-change` bereit. Ist sie schon da, zeichnen wir sofort. */
      if (window.CbKauf && typeof window.CbKauf.getState === 'function') {
        try {
          this.render(window.CbKauf.getState());
        } catch (e) {
          /* Variante noch nicht bereit — das Event holt es nach. */
        }
      } else {
        this.render(this.fallbackState());
      }
    }

    /* Ohne Variante (z. B. Theme-Editor-Vorschau ohne V4/V5) zeigt die Leiste
       wenigstens Titel und Preis des Produkts. */
    fallbackState() {
      return {
        base: { title: this.dataset.baseTitle || '', price: parseInt(this.dataset.basePrice || '0', 10) },
        items: [],
        total: parseInt(this.dataset.basePrice || '0', 10),
        vehicle: '',
        savings: 0
      };
    }

    bindState() {
      this.onConfig = (e) => {
        if (e && e.detail) this.render(e.detail);
      };
      document.addEventListener('cb:config-change', this.onConfig);
    }

    /* --------------------------------------------------------------- Zeichnen */

    render(state) {
      if (!state || !state.base) return;
      this.state = state;

      var total = typeof state.total === 'number' ? state.total : state.base.price;
      if (this.totalEl) this.totalEl.textContent = cbPrice(total);

      var saved = this.showSavings ? Math.round(Number(state.savings) || 0) : 0;
      if (this.savingsEl) {
        if (saved > 0) {
          this.savingsEl.textContent = cbKaufT('savings').replace('[amount]', cbPrice(saved));
          this.savingsEl.hidden = false;
        } else {
          this.savingsEl.textContent = '';
          this.savingsEl.hidden = true;
        }
      }

      this.setMarqueeText(this.summaryLine(state));
      if (this.open) this.renderList();
      this.measureHeight();
    }

    /* `base.title · 1 × shortTitle · … · vehicle` — ohne Betraege, mit den
       Kurztiteln der Add-ons. */
    summaryLine(state) {
      var parts = [];
      if (state.base && state.base.title) parts.push(state.base.title);
      var items = this.chosen(state);
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var name = it.shortTitle || it.title || '';
        parts.push(it.qty + ' × ' + name);
      }
      if (state.vehicle) parts.push(state.vehicle);
      return parts.join(' · ');
    }

    chosen(state) {
      var items = (state && state.items) || [];
      var out = [];
      for (var i = 0; i < items.length; i++) {
        if ((Number(items[i].qty) || 0) > 0) out.push(items[i]);
      }
      return out;
    }

    /* ------------------------------------------------------------ Positionen */

    renderList() {
      if (!this.panelBody || !this.state) return;
      var state = this.state;
      var items = this.chosen(state);

      /* Signatur aus Reihenfolge und Art: bleibt sie gleich, werden nur Menge
         und Zeilensumme nachgezogen — sonst verloere der Finger nach jedem
         Tipp auf „+“ den Fokus auf dem Knopf. */
      var sig = 'b|' + (state.base.title || '') + '|' + items.map(function (i) { return i.id + ':' + i.kind; }).join(',') + '|v' + (state.vehicle ? '1' : '0');

      if (this.rendered !== sig) {
        this.panelBody.textContent = '';
        var ul = document.createElement('ul');
        ul.className = 'cb-kauf-bar__list';
        ul.setAttribute('data-cb-list', '');
        ul.appendChild(this.baseRow(state));
        for (var i = 0; i < items.length; i++) ul.appendChild(this.addonRow(items[i]));
        if (state.vehicle) ul.appendChild(this.vehicleRow(state.vehicle));
        this.panelBody.appendChild(ul);
        this.rendered = sig;
      }

      /* Werte nachziehen (auch direkt nach dem Neubau — eine Quelle). */
      var baseAmount = this.panelBody.querySelector('[data-cb-base-amount]');
      if (baseAmount) baseAmount.textContent = cbPrice(state.base.price);
      var baseTitle = this.panelBody.querySelector('[data-cb-base-title]');
      if (baseTitle) baseTitle.textContent = state.base.title || '';

      var rows = this.panelBody.querySelectorAll('[data-cb-row]');
      var byId = {};
      for (var r = 0; r < rows.length; r++) byId[rows[r].getAttribute('data-cb-row')] = rows[r];

      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        /* Nachschlagen ueber eine Karte statt ueber einen Attribut-Selektor:
           Variant-IDs beginnen mit einer Ziffer, und die in einen Selektor zu
           setzen erfordert eine Maskierung, die je nach Browser abweicht. */
        var row = byId[String(it.id)];
        if (!row) continue;
        var amount = row.querySelector('[data-cb-line-amount]');
        if (amount) amount.textContent = cbPrice((Number(it.price) || 0) * (Number(it.qty) || 0));
        var qty = row.querySelector('[data-cb-qty]');
        if (qty) qty.textContent = String(it.qty);
        var minus = row.querySelector('[data-cb-step="-1"]');
        var plus = row.querySelector('[data-cb-step="1"]');
        if (minus) minus.disabled = (Number(it.qty) || 0) <= 0;
        if (plus) plus.disabled = (Number(it.max) || 0) > 0 && (Number(it.qty) || 0) >= Number(it.max);
      }

      var vv = this.panelBody.querySelector('[data-cb-vehicle-value]');
      if (vv) vv.textContent = state.vehicle || '';
    }

    baseRow(state) {
      var li = document.createElement('li');
      li.className = 'cb-kauf-bar__item cb-kauf-bar__item--base';
      var title = document.createElement('span');
      title.className = 'cb-kauf-bar__item-title';
      title.setAttribute('data-cb-base-title', '');
      title.textContent = state.base.title || '';
      var amount = document.createElement('span');
      amount.className = 'cb-kauf-bar__amount';
      amount.setAttribute('data-cb-base-amount', '');
      li.appendChild(title);
      li.appendChild(amount);
      return li;
    }

    addonRow(item) {
      var self = this;
      var li = document.createElement('li');
      li.className = 'cb-kauf-bar__item cb-kauf-bar__item--addon';
      li.setAttribute('data-cb-row', String(item.id));

      var title = document.createElement('span');
      title.className = 'cb-kauf-bar__item-title';
      title.textContent = item.title || item.shortTitle || '';
      li.appendChild(title);

      if (item.kind === 'toggle') {
        /* Ein Regler waere hier eine Frage ohne Antwort: die Position gibt es
           einmal oder gar nicht. */
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'cb-kauf-bar__remove';
        rm.textContent = cbKaufT('remove');
        rm.setAttribute('aria-label', cbKaufT('remove_item').replace('[title]', item.title || ''));
        rm.addEventListener('click', function () { self.remove(item.id); });
        li.appendChild(rm);
      } else {
        var stepper = document.createElement('span');
        stepper.className = 'cb-kauf-bar__stepper';

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'cb-kauf-bar__step';
        minus.setAttribute('data-cb-step', '-1');
        minus.setAttribute('aria-label', cbKaufT('step_down').replace('[title]', item.title || ''));
        minus.appendChild(cbSvg(['M5 10h10'], 20));
        minus.addEventListener('click', function () { self.step(item.id, -1); });

        var out = document.createElement('output');
        out.className = 'cb-kauf-bar__qty';
        out.setAttribute('data-cb-qty', '');
        out.setAttribute('aria-label', cbKaufT('qty').replace('[title]', item.title || ''));

        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'cb-kauf-bar__step';
        plus.setAttribute('data-cb-step', '1');
        plus.setAttribute('aria-label', cbKaufT('step_up').replace('[title]', item.title || ''));
        plus.appendChild(cbSvg(['M5 10h10', 'M10 5v10'], 20));
        plus.addEventListener('click', function () { self.step(item.id, 1); });

        stepper.appendChild(minus);
        stepper.appendChild(out);
        stepper.appendChild(plus);
        li.appendChild(stepper);
      }

      var amount = document.createElement('span');
      amount.className = 'cb-kauf-bar__amount';
      amount.setAttribute('data-cb-line-amount', '');
      li.appendChild(amount);
      return li;
    }

    vehicleRow(value) {
      var li = document.createElement('li');
      li.className = 'cb-kauf-bar__item cb-kauf-bar__item--vehicle';
      var label = document.createElement('span');
      label.className = 'cb-kauf-bar__item-title';
      label.textContent = cbKaufT('vehicle');
      var v = document.createElement('span');
      v.className = 'cb-kauf-bar__vehicle-value';
      v.setAttribute('data-cb-vehicle-value', '');
      v.textContent = value;
      li.appendChild(label);
      li.appendChild(v);
      return li;
    }

    step(id, delta) {
      if (window.CbKauf && typeof window.CbKauf.step === 'function') window.CbKauf.step(id, delta);
    }

    remove(id) {
      if (window.CbKauf && typeof window.CbKauf.remove === 'function') window.CbKauf.remove(id);
    }

    /* ------------------------------------------------------------ Laufschrift */

    setMarqueeText(text) {
      if (!this.mqText) return;
      if (this.mqText.textContent === text) return;
      this.mqText.textContent = text;
      if (this.mq) this.mq.title = text;
      if (this.mqClone) this.mqClone.textContent = text;
      this.updateMarquee();
    }

    bindMarquee() {
      var self = this;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = function () { self.updateMarquee(); };
      if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.onMotion);
      else if (this.motionQuery.addListener) this.motionQuery.addListener(this.onMotion);

      this.onVisibility = function () {
        if (!self.mqTrack) return;
        self.mqTrack.style.animationPlayState = document.hidden ? 'paused' : 'running';
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      if (window.ResizeObserver && this.mq) {
        /* Beobachtet wird die Spalte — sie wird beim Drehen des Geraets
           schmaler. Der Text selbst ist ein Inline-Element und meldet an einen
           ResizeObserver nichts; sein zweiter Anlass, breiter zu werden, ist
           der Wechsel von der Ersatz- zur eigenen Schrift, und den meldet
           `document.fonts.ready`. */
        this.mqObserver = new ResizeObserver(function () { self.updateMarquee(); });
        this.mqObserver.observe(this.mq);
      }
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(function () { self.updateMarquee(); });
      }
      this.updateMarquee();
    }

    /* Gemessen wird die EINE Kopie, nie die Spur: sobald dupliziert wird, ist
       deren Breite das Doppelte, und die Zeile hielte sich fuer immer zu breit.
       Gemessen wird ausserdem der Text OHNE den 32px-Abstand der laufenden
       Kopie — sonst waechst die Messung, sobald die Zeile laeuft. */
    updateMarquee() {
      if (!this.mq || !this.mqTrack || !this.mqText) return;
      var available = this.mq.clientWidth;
      /* `getBoundingClientRect` statt `scrollWidth`: der Text steht als
         Inline-Element in der Kopie, und `scrollWidth` liefert dort 0. */
      var content = Math.ceil(this.mqText.getBoundingClientRect().width);
      var overflows = cbNeedsMarquee(content, available);
      var reduced = this.motionQuery ? this.motionQuery.matches : false;
      var running = overflows && !reduced;
      var mode = running ? 'running' : overflows ? 'swipe' : 'static';
      if (this.mq.getAttribute('data-marquee') !== mode) this.mq.setAttribute('data-marquee', mode);

      if (running) {
        if (!this.mqClone) {
          /* Die zweite Kopie ist reine Optik: vorgelesen kaeme die Zeile sonst
             doppelt an. */
          this.mqClone = document.createElement('span');
          this.mqClone.className = 'cb-kauf-bar__mq-copy';
          this.mqClone.setAttribute('aria-hidden', 'true');
          this.mqClone.textContent = this.mqText.textContent;
          this.mqTrack.appendChild(this.mqClone);
        }
        var duration = cbMarqueeDuration(content + CB_MARQUEE_GAP);
        this.mqTrack.style.animationDuration = duration + 's';
        this.mqTrack.style.animationPlayState = document.hidden ? 'paused' : 'running';
        this.mqTrack.setAttribute('data-cb-duration', String(duration));
      } else {
        if (this.mqClone) {
          this.mqClone.remove();
          this.mqClone = null;
        }
        this.mqTrack.style.animationDuration = '';
        this.mqTrack.style.animationPlayState = '';
        this.mqTrack.removeAttribute('data-cb-duration');
      }
    }

    /* --------------------------------------------------------- Auf-/Zuklappen */

    setOpen(next) {
      if (this.open === next) return;
      this.open = next;
      this.classList.toggle('is-open', next);
      if (this.panel) this.panel.hidden = !next;
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', next ? 'true' : 'false');
      if (this.detailsBtn) this.detailsBtn.setAttribute('aria-expanded', next ? 'true' : 'false');
      var label = next ? cbKaufT('hide_items') : cbKaufT('show_items');
      if (this.toggleSr) this.toggleSr.textContent = label;
      if (this.detailsSr) this.detailsSr.textContent = label;
      if (this.hintEl) this.hintEl.hidden = !next;
      if (this.mq) this.mq.hidden = next;
      if (this.taxEl) this.taxEl.hidden = !next;
      if (this.adviceEl) this.adviceEl.hidden = !next;

      if (next) {
        this.renderList();
        this.setVisible(true);
      } else {
        /* Panel-Inhalt nur gerendert, wenn offen. */
        if (this.panelBody) this.panelBody.textContent = '';
        this.rendered = null;
        this.measureHeight();
      }
      if (!next) this.updateMarquee();
    }

    bindInteractions() {
      var self = this;
      if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () { self.setOpen(!self.open); });
      if (this.detailsBtn) this.detailsBtn.addEventListener('click', function () { self.setOpen(!self.open); });

      this.onKeydown = function (e) {
        if (e.key !== 'Escape' || !self.open) return;
        self.setOpen(false);
        var focus = window.matchMedia('(min-width: ' + CB_TABLET + 'px)').matches ? self.detailsBtn : self.toggleBtn;
        if (focus) focus.focus();
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    /* ------------------------------------------------------------ Kauf-Proxy */

    nativeButton() {
      return document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
    }

    /* Der geklemmte Originalblock darf MIT JavaScript nicht in der
       Tab-Reihenfolge stehen. Sonst tabbt man hin, hoert „In den Warenkorb“
       vom Screenreader, drueckt Enter — und der normale Theme-Weg laeuft an
       `CbKaufCheckout` samt Weiterleitung auf `/checkout` vorbei: Der Kunde
       landet im Warenkorb-Drawer statt an der Kasse. `inert` nimmt Fokus,
       Klick und Vorlesen in einem Zug.

       Ausdruecklich per JS und nicht im Markup: OHNE JavaScript ist dieser
       Knopf der einzige Bestellweg und muss bedienbar bleiben — dieselbe
       Klammer wie beim Inline-Style oben. `CbKaufCheckout` schickt darum das
       Formular per `requestSubmit()` ab; wie sich `inert` gegenueber einem
       programmatischen Klick verhaelt, steht dort. */
    applyInert() {
      var sel = this.dataset.nativeSelector || '';
      if (!sel) return;
      var nodes;
      try {
        nodes = document.querySelectorAll(sel);
      } catch (error) {
        /* Unbrauchbarer Selektor aus dem Theme-Editor — dann eben ohne. */
        return;
      }
      for (var i = 0; i < nodes.length; i++) {
        if (!nodes[i].hasAttribute('inert')) nodes[i].setAttribute('inert', '');
      }
    }

    /* Rueckmeldung in der Leiste. Sie zeigt sich dabei selbst: Eine Meldung
       unterhalb des Fensterrands ist keine. */
    notice(text) {
      if (!this.noticeEl) return;
      this.noticeEl.textContent = text || '';
      this.noticeEl.hidden = !text;
      if (text) this.setVisible(true);
      this.measureHeight();
    }

    bindPrimary() {
      var self = this;
      if (!this.primaryBtn) return;
      this.primaryBtn.addEventListener('click', function () {
        self.notice('');
        window.CbKaufCheckout({
          button: self.primaryBtn,
          checkout: self.dataset.checkout !== 'false',
          notify: function (text) {
            self.notice(text);
          },
          onReset: function () {
            if (self.syncPrimary) self.syncPrimary();
          },
        });
      });

      var sync = function () {
        /* Bei jedem Abgleich mit: Horizon zeichnet den Kaufblock beim
           Variantenwechsel neu, und der Modellwechsel tauscht `main`
           komplett — der neue Block kaeme sonst ohne `inert`. */
        self.applyInert();
        var native = self.nativeButton();
        if (!native) {
          /* Horizon zeichnet den Kaufblock beim Variantenwechsel neu. Ist der
             beobachtete Button verschwunden, muss der grobe Beobachter wieder
             mitlaufen, sonst bliebe der Proxy auf dem letzten Stand haengen. */
          if (self.nativeWatch && self.bodyObserver) {
            self.nativeWatch = null;
            self.bodyObserver.observe(document.body, { childList: true, subtree: true });
          }
          return;
        }
        self.primaryBtn.disabled = !!native.disabled || native.getAttribute('aria-disabled') === 'true';
        if (self.nativeWatch !== native) {
          self.nativeWatch = native;
          if (self.nativeObserver) self.nativeObserver.disconnect();
          self.nativeObserver = new MutationObserver(sync);
          self.nativeObserver.observe(native, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
          /* Gefunden — der grobe Beobachter auf dem Body hat seine Arbeit getan. */
          if (self.bodyObserver) self.bodyObserver.disconnect();
        }
      };
      this.syncPrimary = sync;
      /* Der Originalbutton kommt in Horizon aus einer eigenen Section und kann
         nach uns im Baum landen. Der Beobachter steht deshalb VOR dem ersten
         Abgleich — findet der ihn sofort, raeumt er sich selbst wieder ab. */
      this.bodyObserver = new MutationObserver(function () {
        if (!self.nativeWatch || !self.nativeWatch.isConnected) sync();
      });
      this.bodyObserver.observe(document.body, { childList: true, subtree: true });
      sync();
      document.addEventListener('cb:config-change', sync);
      document.addEventListener('cb:main-replaced', sync);
      this.onConfigSync = sync;
    }

    /* -------------------------------------------------------------- Geometrie */

    bindHeight() {
      var self = this;
      if (window.ResizeObserver && this.bottom) {
        this.heightObserver = new ResizeObserver(function () { self.measureHeight(); });
        this.heightObserver.observe(this.bottom);
      }
      this.onResize = function () { self.measureHeight(); self.updateMarquee(); self.updateVisible(); };
      window.addEventListener('resize', this.onResize);
      this.measureHeight();
    }

    /* `--cb-kauf-bar-h` ist die Hoehe der EINGEKLAPPTEN Leiste. Im
       aufgeklappten Zustand traegt `[data-cb-bottom]` zusaetzlich die
       MwSt.- und die Beratungszeile — wuerde die Zahl dort fortgeschrieben,
       spraenge der Seitenfuss beim Aufklappen. */
    measureHeight() {
      if (!this.bottom || this.open) return;
      var h = Math.ceil(this.bottom.getBoundingClientRect().height);
      if (!h || h === this.lastHeight) return;
      this.lastHeight = h;
      document.documentElement.style.setProperty('--cb-kauf-bar-h', h + 'px');
      document.body.style.paddingBottom = h + 'px';
      document.documentElement.style.scrollPaddingBottom = h + 'px';
    }

    /* ---------------------------------------------------------------- Scroll */

    bindScroll() {
      var self = this;
      var ticking = false;
      this.onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          self.updateVisible();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateVisible();
    }

    /* Sichtbar ab der Schwelle und dann dauerhaft — anders als der globale
       Floating-Button, der beim Hochscrollen wieder verschwindet. Am Seitenende
       bleibt sie damit stehen. Ist die Seite zu kurz, um die Schwelle je zu
       erreichen, zeigt sie sich sofort. */
    updateVisible() {
      var threshold = parseInt(this.dataset.threshold || '200', 10);
      var doc = document.documentElement;
      var scrollable = Math.max(0, doc.scrollHeight - window.innerHeight);
      var visible = this.open || window.scrollY > threshold || scrollable <= threshold;
      this.setVisible(visible);
    }

    setVisible(next) {
      if (this.visible === next) return;
      this.visible = next;
      this.classList.toggle('is-visible', next);
    }

    /* ------------------------------------------------------- Geschaeftszeiten */

    viennaNow() {
      try {
        var fmt = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Vienna',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        });
        var parts = {};
        fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return { day: dayMap[parts.weekday], hour: parseInt(parts.hour, 10) % 24, minute: parseInt(parts.minute, 10) };
      } catch (e) {
        var d = new Date();
        return { day: d.getDay(), hour: d.getHours(), minute: d.getMinutes() };
      }
    }

    isOpenNow() {
      try {
        var test = new URLSearchParams(window.location.search).get('cb_test');
        if (test === 'open') return true;
        if (test === 'closed') return false;
      } catch (e) {
        /* ignorieren */
      }
      if (this.dataset.forceClosed === 'true') return false;
      var days = (this.dataset.days || '').split(',').filter(Boolean).map(function (n) { return parseInt(n, 10); });
      var openH = parseFloat(this.dataset.open || '9');
      var closeH = parseFloat(this.dataset.close || '17');
      var now = this.viennaNow();
      var t = now.hour + now.minute / 60;
      return days.indexOf(now.day) !== -1 && t >= openH && t < closeH;
    }

    applyHours() {
      if (!this.phoneWrap) return;
      this.phoneWrap.hidden = !this.isOpenNow();
    }

    /* ------------------------------------------------------------- Aufraeumen */

    disconnectedCallback() {
      if (this.onConfig) document.removeEventListener('cb:config-change', this.onConfig);
      if (this.onConfigSync) {
        document.removeEventListener('cb:config-change', this.onConfigSync);
        document.removeEventListener('cb:main-replaced', this.onConfigSync);
      }
      if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.mqObserver) this.mqObserver.disconnect();
      if (this.heightObserver) this.heightObserver.disconnect();
      if (this.nativeObserver) this.nativeObserver.disconnect();
      if (this.bodyObserver) this.bodyObserver.disconnect();
      if (this.hoursTimer) window.clearInterval(this.hoursTimer);
      if (this.motionQuery && this.onMotion) {
        if (this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this.onMotion);
        else if (this.motionQuery.removeListener) this.motionQuery.removeListener(this.onMotion);
      }
      document.body.style.paddingBottom = '';
      document.documentElement.style.scrollPaddingBottom = '';
      document.documentElement.style.removeProperty('--cb-kauf-bar-h');
    }
  }

  if (!customElements.get('cb-kauf-bar')) customElements.define('cb-kauf-bar', CbKaufBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-kauf-v5-setup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cb-kauf-v5-setup')) return;

    var STORE_KEY = 'cb-kauf-v5-vehicle';
    /* Je Fahrzeug ein Merker: Wer bei der V-Klasse „ohne" gesagt hat, soll beim Wechsel auf
       einen Multivan wieder gefragt werden — es ist eine andere Frage. */
    var ASKED_KEY = 'cb-kauf-v5-rail-asked';

    function icon(check) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '18');
      svg.setAttribute('height', '18');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', check ? 'm4.5 12.5 5 5 10-11' : 'M12 8v5m0 3.5v.01M12 3.5 21 20H3Z');
      svg.appendChild(path);
      return svg;
    }

    function line(text, isCheck) {
      var wrap = document.createElement('div');
      wrap.className = 'cb-kauf-v5-setup__line';
      var mark = document.createElement('span');
      mark.className =
        'cb-kauf-v5-setup__line-icon' + (isCheck ? '' : ' cb-kauf-v5-setup__line-icon--info');
      mark.appendChild(icon(isCheck));
      var body = document.createElement('span');
      body.textContent = text;
      wrap.appendChild(mark);
      wrap.appendChild(body);
      return wrap;
    }

    class CbKaufV5Setup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.image = this.querySelector('[data-cb-v5-setup-image]');
        this.bubbles = this.querySelector('[data-cb-v5-setup-bubbles]');
        this.emptyNote = this.querySelector('[data-cb-v5-setup-empty]');
        this.list = this.querySelector('[data-cb-v5-setup-list]');
        this.modelName = this.querySelector('[data-cb-v5-setup-model]');
        this.baseAmount = this.querySelector('[data-cb-v5-setup-base]');
        this.totalValue = this.querySelector('[data-cb-v5-setup-total]');
        this.buyBtn = this.querySelector('[data-cb-v5-setup-buy]');
        this.buyNotice = this.querySelector('[data-cb-v5-setup-notice]');

        this.field = this.querySelector('[data-cb-vf-field]');
        this.select = this.querySelector('[data-cb-veh-select]');
        this.chosen = this.querySelector('[data-cb-veh-chosen]');
        this.chosenText = this.querySelector('[data-cb-veh-chosen-text]');
        this.otherWrap = this.querySelector('[data-cb-veh-other]');
        this.otherInput = this.querySelector('[data-cb-veh-other-input]');
        this.feedback = this.querySelector('[data-cb-veh-feedback]');
        this.prop = this.querySelector('[data-cb-veh-prop]');
        this.dialog = this.querySelector('[data-cb-rail-dialog]');
        this.detail = this.querySelector('[data-cb-detail-dialog]');
        this.bindDetail();

        this.onConfig = this.render.bind(this);
        document.addEventListener('cb:config-change', this.onConfig);

        /* Beim Modellwechsel wird `main` samt Produktformular ausgetauscht — die Eigenschaft
           muss danach am neuen Formular hängen, sonst fährt das Fahrzeug nicht mit. */
        this.onReplaced = this.attachForm.bind(this);
        document.addEventListener('cb:main-replaced', this.onReplaced);

        this.bindVehicle();

        if (this.buyBtn) {
          this.onBuy = this.buy.bind(this);
          this.buyBtn.addEventListener('click', this.onBuy);
        }

        this.render();
      }

      disconnectedCallback() {
        if (this.onConfig) document.removeEventListener('cb:config-change', this.onConfig);
        if (this.onReplaced) document.removeEventListener('cb:main-replaced', this.onReplaced);
        if (this.buyBtn && this.onBuy) this.buyBtn.removeEventListener('click', this.onBuy);
        if (this.select && this.onSelect) this.select.removeEventListener('change', this.onSelect);
        if (this.otherInput && this.onOther) {
          this.otherInput.removeEventListener('input', this.onOther);
          this.otherInput.removeEventListener('change', this.onOther);
        }
        if (this.formTimer) window.clearInterval(this.formTimer);
        if (this.formStop) window.clearTimeout(this.formStop);
        if (this.dialog && this.onCancel) this.dialog.removeEventListener('cancel', this.onCancel);
        if (this.dialog && this.onBackdrop) this.dialog.removeEventListener('click', this.onBackdrop);
        if (this.detail && this.onDetailCancel) {
          this.detail.removeEventListener('cancel', this.onDetailCancel);
        }
        if (this.detail && this.onDetailBackdrop) {
          this.detail.removeEventListener('click', this.onDetailBackdrop);
        }
        delete this.dataset.cbInit;
      }

      bindDetail() {
        var self = this;
        if (!this.detail) return;

        this.querySelectorAll('[data-cb-detail-close]').forEach(function (button) {
          button.addEventListener('click', function () {
            self.closeDetail();
          });
        });

        var minus = this.querySelector('[data-cb-detail-minus]');
        if (minus) {
          minus.addEventListener('click', function () {
            if (window.CbKauf && self.detailId) window.CbKauf.step(self.detailId, -1);
          });
        }
        var plus = this.querySelector('[data-cb-detail-plus]');
        if (plus) {
          plus.addEventListener('click', function () {
            if (window.CbKauf && self.detailId) window.CbKauf.step(self.detailId, 1);
          });
        }
        var remove = this.querySelector('[data-cb-detail-remove]');
        if (remove) {
          remove.addEventListener('click', function () {
            if (window.CbKauf && self.detailId) window.CbKauf.remove(self.detailId);
          });
        }

        this.onDetailCancel = function (event) {
          event.preventDefault();
          self.closeDetail();
        };
        this.detail.addEventListener('cancel', this.onDetailCancel);
        this.onDetailBackdrop = function (event) {
          if (event.target === self.detail) self.closeDetail();
        };
        this.detail.addEventListener('click', this.onDetailBackdrop);
      }

      /* ------------------------------------------------------------- Fahrzeug */

      /* Die Karte an den Zustand angleichen — nach der Wahl und nach `restore()`. */
      syncCard(value, isOther) {
        if (!this.field) return;
        var known = !!value && !isOther;
        this.field.classList.toggle('cb-kauf-v5-setup__vehicle-field--chosen', known);

        if (this.chosen) {
          this.chosen.hidden = !known;
          if (known && this.chosenText) this.chosenText.textContent = value;
        }
        /* Steht die Zusammenfassung, wäre die Rückmeldung darunter dieselbe Aussage zweimal. */
        if (this.feedback && known) this.feedback.hidden = true;
      }

      bindVehicle() {
        var self = this;
        if (!this.select) return;

        var change = this.querySelector('[data-cb-veh-change]');
        if (change) {
          change.addEventListener('click', function () {
            if (!self.field) return;
            self.field.classList.remove('cb-kauf-v5-setup__vehicle-field--chosen');
            if (self.chosen) self.chosen.hidden = true;
            if (self.feedback && self.select && self.select.value) self.feedback.hidden = false;
            if (self.select) self.select.focus();
          });
        }

        this.onSelect = function () {
          self.handleSelect(true);
        };
        this.select.addEventListener('change', this.onSelect);

        if (this.otherInput) {
          this.onOther = this.handleOther.bind(this);
          this.otherInput.addEventListener('input', this.onOther);
          this.otherInput.addEventListener('change', this.onOther);
        }

        this.attachForm();
        this.formTimer = window.setInterval(this.attachForm.bind(this), 500);
        this.formStop = window.setTimeout(
          function () {
            window.clearInterval(self.formTimer);
            self.formTimer = null;
          },
          8000
        );

        if (this.dialog) {
          var add = this.querySelector('[data-cb-rail-add]');
          var skip = this.querySelector('[data-cb-rail-skip]');
          if (add) add.addEventListener('click', this.acceptRail.bind(this));
          if (skip) skip.addEventListener('click', this.skipRail.bind(this));
          /* Escape löst `cancel` aus — dasselbe wie „ohne weiter". */
          this.onCancel = function (event) {
            event.preventDefault();
            self.skipRail();
          };
          this.dialog.addEventListener('cancel', this.onCancel);
          this.onBackdrop = function (event) {
            if (event.target === self.dialog) self.skipRail();
          };
          this.dialog.addEventListener('click', this.onBackdrop);
        }

        this.restore();
      }

      attachForm() {
        if (!this.prop) return;
        var api = window.CbKaufV5;
        var form = api ? api.form() : document.querySelector('form[data-type="add-to-cart-form"]');
        /* getAttribute, nicht .id: HTMLFormElement überschreibt eingebaute Eigenschaften mit
           gleichnamigen Feldern — form.id liefert den hidden <input name="id">. */
        var fid = form ? form.getAttribute('id') : '';
        if (fid && this.prop.getAttribute('form') !== fid) this.prop.setAttribute('form', fid);
      }

      store(key, value) {
        try {
          if (value) window.sessionStorage.setItem(key, value);
          else window.sessionStorage.removeItem(key);
        } catch (error) {
          /* sessionStorage kann blockiert sein — dann eben ohne Gedächtnis. */
        }
      }

      read(key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      restore(draftVehicle) {
        var saved = typeof draftVehicle === 'string' ? draftVehicle : this.read(STORE_KEY);
        if (typeof draftVehicle === 'string') this.store(STORE_KEY, draftVehicle);
        if (!saved || !this.select) {
          if (this.select) { this.select.value = ''; this.handleSelect(); }
          this.setProperty('');
          return;
        }
        for (var i = 0; i < this.select.options.length; i += 1) {
          if (this.select.options[i].value === saved) {
            this.select.selectedIndex = i;
            this.handleSelect();
            return;
          }
        }
        var other = this.select.querySelector('[data-other]');
        if (!other) return;
        this.select.value = other.value;
        if (this.otherInput) this.otherInput.value = saved;
        this.handleSelect();
      }

      setProperty(value) {
        if (!this.prop) return;
        this.attachForm();
        this.prop.value = value || '';
        this.prop.disabled = !value;
        if (window.CbKaufV5) window.CbKaufV5.setVehicle(value || '');
      }

      handleOther() {
        var typed = this.otherInput ? this.otherInput.value.trim() : '';
        this.setProperty(typed);
        this.store(STORE_KEY, typed);
      }

      handleSelect(fromUser) {
        if (!this.select) return;
        var option = this.select.options[this.select.selectedIndex];
        var value = this.select.value;
        var isOther = !!(option && option.dataset.other);
        var isRail = !!(option && option.dataset.rail);

        if (this.otherWrap) this.otherWrap.hidden = !isOther;

        if (!value) {
          if (this.feedback) {
            this.feedback.textContent = '';
            this.feedback.hidden = true;
          }
          this.setProperty('');
          this.store(STORE_KEY, '');
          this.syncCard('', false);
          return;
        }

        if (isOther) {
          var typed = this.otherInput ? this.otherInput.value.trim() : '';
          this.setProperty(typed);
          this.store(STORE_KEY, typed);
          this.renderOther();
          this.syncCard(typed, true);
          if (fromUser && this.otherInput) this.otherInput.focus();
          return;
        }

        this.setProperty(value);
        this.store(STORE_KEY, value);
        this.renderKnown(value);
        this.syncCard(value, false);
        if (isRail) this.maybeAskRail(value);
      }

      renderKnown(value) {
        if (!this.feedback) return;
        this.feedback.textContent = '';
        this.feedback.hidden = false;
        var text = (this.dataset.okText || '').replace(
          '[fahrzeug]',
          value
        );
        this.feedback.appendChild(line(text, true));
      }

      renderOther() {
        if (!this.feedback) return;
        this.feedback.textContent = '';
        this.feedback.hidden = false;
        this.feedback.appendChild(line(this.dataset.otherText || '', false));

        var links = document.createElement('div');
        links.className = 'cb-kauf-v5-setup__links';

        var check = document.createElement('a');
        check.href = this.dataset.checkUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'pages/fahrzeugcheck';
        check.textContent = this.dataset.checkLabel || '';
        check.target = '_blank';
        check.rel = 'noopener';
        links.appendChild(check);

        var advice = document.createElement('a');
        advice.href = this.dataset.adviceUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'pages/kostenloser-beratungstermin';
        advice.textContent = this.dataset.adviceLabel || '';
        links.appendChild(advice);

        this.feedback.appendChild(links);
      }

      /* --------------------------------------------------------- Schienenfrage */

      /* Die Schienenmontage wird über den Kartentitel gefunden, nicht über eine ID im Code:
         Die IDs stehen in den Metafeldern des Shops, nicht im Theme. */
      railCard() {
        var needle = (this.dataset.railMatch || 'Schienenmontage').toLowerCase();
        var cards = document.querySelectorAll('[data-cb-v5-card]');
        for (var i = 0; i < cards.length; i += 1) {
          var title = (cards[i].dataset.cbTitle || '').toLowerCase();
          if (title.indexOf(needle) !== -1) return cards[i];
          if (cards[i].dataset.cbRail === '1') return cards[i];
        }
        return null;
      }

      askedFor(vehicle) {
        return this.read(ASKED_KEY) === vehicle;
      }

      maybeAskRail(vehicle) {
        var api = window.CbKaufV5;
        if (!api || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        if (this.askedFor(vehicle)) return;

        var card = this.railCard();
        if (!card) return;
        var id = card.dataset.cbId;
        if (!id || api.get(id) > 0) return;

        this.railId = id;
        this.railVehicle = vehicle;

        var image = this.querySelector('[data-cb-rail-image]');
        if (image) {
          var src = card.dataset.cbImage || '';
          if (src && image.getAttribute('src') !== src) image.setAttribute('src', src);
          image.setAttribute('alt', card.dataset.cbTitle || '');
          image.hidden = !src;
        }

        var text = this.querySelector('[data-cb-rail-text]');
        if (text) {
          text.textContent = (this.dataset.railText || '').replace('[fahrzeug]', vehicle);
        }

        var price = this.querySelector('[data-cb-rail-price]');
        if (price) price.textContent = api.money(card.dataset.cbPrice || 0);

        this.returnFocus = this.select;
        this.dialog.showModal();
        var add = this.querySelector('[data-cb-rail-add]');
        if (add) add.focus();
      }

      closeRail() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.returnFocus && typeof this.returnFocus.focus === 'function') {
          this.returnFocus.focus();
        }
      }

      acceptRail() {
        if (window.CbKauf && this.railId) window.CbKauf.step(this.railId, 1);
        /* Auch nach dem Hinzufügen merken: Wer sie später wieder entfernt, hat sich entschieden
           und soll nicht beim nächsten Blick aufs Select erneut gefragt werden. */
        this.store(ASKED_KEY, this.railVehicle || '');
        this.closeRail();
      }

      skipRail() {
        this.store(ASKED_KEY, this.railVehicle || '');
        this.closeRail();
      }

      /* Rueckmeldung neben dem Knopf. Ohne sie brach der Kauf still ab —
         `CbKaufCheckout` fehlte, der Warenkorb wollte nicht, egal: Der Knopf
         tat auf einen Klick nichts, und niemand erfuhr, warum. */
      notice(text) {
        if (!this.buyNotice) return;
        this.buyNotice.textContent = text || '';
        this.buyNotice.hidden = !text;
      }

      buy() {
        var self = this;
        this.notice('');
        if (typeof window.CbKaufCheckout !== 'function') {
          this.notice(this.dataset.notReady || '');
          return;
        }
        window.CbKaufCheckout({
          button: this.buyBtn,
          checkout: this.dataset.checkout !== 'false',
          notify: function (text) {
            self.notice(text);
          },
        });
      }

      /* Ein Kreis je Position. Die Bild-URL wird nur geschrieben, wenn sie sich geaendert hat —
         sonst laedt der Browser dasselbe Motiv bei jeder Mengenaenderung neu und die Reihe
         flackert. */
      renderBubbles(items) {
        if (!this.bubbles) return;
        var existing = {};
        var seen = {};
        var self = this;

        this.bubbles.querySelectorAll('[data-cb-cell]').forEach(function (node) {
          existing[node.getAttribute('data-cb-cell')] = node;
        });

        items.forEach(function (item) {
          if (!item.image) return;
          seen[item.id] = true;
          var cell = existing[item.id];
          if (!cell) {
            cell = document.createElement('li');
            cell.className = 'cb-kauf-v5-setup__bubble-cell';
            cell.setAttribute('data-cb-cell', item.id);

            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'cb-kauf-v5-setup__bubble';
            button.setAttribute('data-cb-bubble', item.id);
            var img = document.createElement('img');
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            button.appendChild(img);
            var badge = document.createElement('span');
            badge.className = 'cb-kauf-v5-setup__badge';
            badge.setAttribute('data-cb-badge', '');
            button.appendChild(badge);
            button.addEventListener('click', function () {
              self.openDetail(item.id, button);
            });
            cell.appendChild(button);

            var name = document.createElement('span');
            name.className = 'cb-kauf-v5-setup__bubble-name';
            name.setAttribute('data-cb-name', '');
            cell.appendChild(name);
          }

          var short = item.shortTitle || item.title || '';
          var full = item.title || short;

          var picture = cell.querySelector('img');
          if (picture.getAttribute('src') !== item.image) picture.setAttribute('src', item.image);
          if (picture.getAttribute('alt') !== full) picture.setAttribute('alt', full);

          var badgeNode = cell.querySelector('[data-cb-badge]');
          var count = String(item.qty);
          if (badgeNode.textContent !== count) badgeNode.textContent = count;

          var nameNode = cell.querySelector('[data-cb-name]');
          if (nameNode.textContent !== short) nameNode.textContent = short;

          var button = cell.querySelector('[data-cb-bubble]');
          var label = item.qty + ' × ' + full + ' – ' + (self.dataset.detailHint || '');
          if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
          if (button.getAttribute('title') !== full) button.setAttribute('title', full);

          /* Anhaengen bringt die Reihe in dieselbe Ordnung wie die Kaufspalte. */
          self.bubbles.appendChild(cell);
        });

        Object.keys(existing).forEach(function (id) {
          if (!seen[id]) existing[id].remove();
        });
      }

      /* ------------------------------------------------------- Detail-Dialog */

      itemById(id) {
        var api = window.CbKaufV5;
        if (!api) return null;
        var items = api.getState().items;
        for (var i = 0; i < items.length; i += 1) {
          if (String(items[i].id) === String(id)) return items[i];
        }
        return null;
      }

      /* Befuellt wird beim Oeffnen, nicht bei jeder Zustandsmeldung: Ein Dialog, der
         mitrechnet, waehrend er zu ist, laedt Bilder fuer nichts. Offen wird nur die Menge
         fortgeschrieben (`syncDetail`). */
      openDetail(id, source) {
        if (!this.detail || typeof this.detail.showModal !== 'function') return;
        var item = this.itemById(id);
        if (!item) return;

        this.detailId = id;
        this.detailFocus = source || null;

        var image = this.querySelector('[data-cb-detail-image]');
        if (image) {
          /* Erst das kleine, bereits geladene Bubble-Bild zeigen, dann auf das grosse
             wechseln, sobald es da ist — sonst steht die Kachel beim Oeffnen kurz leer. */
          var small = item.image || '';
          var large = item.imageLarge || small;
          image.setAttribute('alt', item.title || '');
          image.hidden = !large;
          if (large && image.getAttribute('src') !== large) {
            if (small) image.setAttribute('src', small);
            var pre = new Image();
            pre.onload = function () {
              if (image.getAttribute('src') !== large && (this.detailId === id)) image.setAttribute('src', large);
            }.bind(this);
            pre.src = large;
          }
        }

        var title = this.querySelector('[data-cb-detail-title]');
        if (title) title.textContent = item.title || item.shortTitle || '';

        var desc = this.querySelector('[data-cb-detail-desc]');
        if (desc) {
          desc.textContent = item.description || '';
          desc.hidden = !item.description;
        }

        var stepper = this.querySelector('[data-cb-detail-stepper]');
        var remove = this.querySelector('[data-cb-detail-remove]');
        var controls = this.querySelector('[data-cb-detail-controls]');
        var isQty = item.kind === 'qty';
        if (stepper) stepper.hidden = !isQty;
        if (remove) remove.hidden = isQty;
        if (controls) controls.hidden = false;

        this.syncDetail();
        this.detail.showModal();
        var close = this.querySelector('[data-cb-detail-close]');
        if (close) close.focus();
      }

      /* Menge und Rechnung im offenen Dialog nachziehen. */
      syncDetail() {
        var api = window.CbKaufV5;
        if (!api || !this.detailId) return;
        var item = this.itemById(this.detailId);

        if (!item) {
          /* Auf 0 gestellt: Die Position gibt es nicht mehr, also auch die Frage nicht. */
          this.closeDetail();
          return;
        }

        var price = this.querySelector('[data-cb-detail-price]');
        if (price) {
          price.textContent =
            item.qty > 1
              ? item.qty + ' × ' + api.money(item.price) + ' = ' + api.money(item.price * item.qty)
              : api.money(item.price);
        }

        var qty = this.querySelector('[data-cb-detail-qty]');
        if (qty) qty.textContent = String(item.qty);
        var minus = this.querySelector('[data-cb-detail-minus]');
        var plus = this.querySelector('[data-cb-detail-plus]');
        if (minus) minus.disabled = item.qty <= 0;
        if (plus) plus.disabled = item.qty >= api.limit(item);
      }

      closeDetail() {
        if (this.detail && this.detail.open) this.detail.close();
        this.detailId = null;
        if (this.detailFocus && typeof this.detailFocus.focus === 'function') {
          /* Der Knopf kann beim Entfernen verschwunden sein — dann bleibt der Fokus, wo er ist,
             statt ins Leere zu greifen. */
          if (this.detailFocus.isConnected) this.detailFocus.focus();
        }
      }

      renderList(state, api) {
        if (!this.list) return;
        var self = this;

        this.list.querySelectorAll('[data-cb-setup-row]').forEach(function (row) {
          row.remove();
        });

        state.items.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'cb-kauf-v5-setup__row cb-kauf-v5-setup__row--addon';
          row.setAttribute('data-cb-setup-row', item.id);

          var name = document.createElement('dt');
          name.textContent = item.qty + ' × ' + (item.title || item.shortTitle || '');

          var amount = document.createElement('dd');
          amount.className = 'cb-kauf-v5-setup__amount';
          amount.textContent = api.money(item.price * item.qty);

          row.appendChild(name);
          row.appendChild(amount);
          self.list.appendChild(row);
        });

        if (state.vehicle) {
          var row = document.createElement('div');
          row.className = 'cb-kauf-v5-setup__row cb-kauf-v5-setup__row--vehicle';
          row.setAttribute('data-cb-setup-row', 'vehicle');
          var label = document.createElement('dt');
          label.textContent = this.dataset.vehicleLabel || '';
          var value = document.createElement('dd');
          value.className = 'cb-kauf-v5-setup__vehicle';
          value.textContent = state.vehicle;
          row.appendChild(label);
          row.appendChild(value);
          this.list.appendChild(row);
        }
      }

      render(event) {
        var api = window.CbKaufV5;
        if (!api) return;
        var state = (event && event.detail) || api.getState();
        if (!state || !state.base) return;

        if (this.image && state.base.image) {
          if (this.image.getAttribute('src') !== state.base.image) {
            this.image.setAttribute('src', state.base.image);
          }
          if (this.image.getAttribute('alt') !== state.base.title) {
            this.image.setAttribute('alt', state.base.title);
          }
          this.image.hidden = false;
        }

        if (this.modelName && this.modelName.textContent !== state.base.title) {
          this.modelName.textContent = state.base.title;
        }
        if (this.baseAmount) this.baseAmount.textContent = api.money(state.base.price);
        if (this.totalValue) this.totalValue.textContent = api.money(state.total);

        this.renderList(state, api);
        this.renderBubbles(state.items);
        if (this.detail && this.detail.open) this.syncDetail();

        if (this.emptyNote) this.emptyNote.hidden = state.items.length > 0;
      }
    }

    customElements.define('cb-kauf-v5-setup', CbKaufV5Setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-kauf-v5-stage"] && !Shopify.designMode) return;
  try {
    
  /* ------------------------------------------------------------------ *
   * Gemeinsamer Zustand der Variante V5.                                *
   * Ein Besitzer für Positionen, Mengen, Fahrzeug und die versteckten   *
   * Warenkorb-Felder. Die Blöcke melden ihre Karten hier an, die Leiste *
   * spricht über window.CbKauf mit derselben Stelle.                    *
   * ------------------------------------------------------------------ */
  (function () {
    if (window.CbKaufV5) return;

    var api = {};
    var entries = [];
    var byId = {};
    var base = { title: '', price: 0, image: '' };
    var vehicle = '';
    var frame = null;
    var draftStore = window.CbConfigDraft;
    var draft = draftStore && draftStore.read();
    var draftMessages = draftStore && draftStore.messages || {};
    var restoringCart = new URLSearchParams(window.location.search).get('cb_wieder') === '1';
    try {
      var cartRestore = JSON.parse(window.sessionStorage.getItem('cbWiederStand'));
      var component = document.querySelector('product-form-component[data-product-id]');
      restoringCart = restoringCart || !!(cartRestore && component && String(cartRestore.produkt) === component.dataset.productId);
    } catch (error) {}
    if (restoringCart) draft = null;
    var lastDraftSignature = draft && draftStore ? draftStore.signature() : null;
    api.draftSignature = function () { return lastDraftSignature; };
    var desired = {};
    var draftReady = false;
    var draftNotice = null;
    var storageFailed = false;
    if (draft) draft.items.forEach(function (item) { desired[item.id] = item; });

    api.remember = function () {
      if (!draftStore || !draftReady || api.switching || restoringCart) return;
      var stored = draftStore.write({ v: 1, z: Date.now(), p: window.location.pathname,
        vehicle: vehicle, items: Object.keys(desired).map(function (id) { return desired[id]; }) });
      storageFailed = !stored;
      if (stored) lastDraftSignature = draftStore.signature();
      api.checkDraft();
    };

    api.draftMessage = function (message) {
      var host = document.querySelector('cb-kauf-v5-setup');
      if (!host) return;
      if (!draftNotice || !draftNotice.isConnected) {
        draftNotice = document.createElement('p');
        draftNotice.setAttribute('role', 'status');
        draftNotice.setAttribute('aria-live', 'polite');
        draftNotice.className = 'cb-config-draft-notice';
        host.prepend(draftNotice);
      }
      draftNotice.textContent = message;
      draftNotice.hidden = !message;
    };

    api.checkDraft = function () {
      var missing = Object.keys(desired).filter(function (id) { return !byId[id] || byId[id].qty !== desired[id].qty; });
      api.draftMessage((storageFailed ? draftMessages.storage_failed + ' ' : '') + (missing.length ? draftMessages.missing_before + ' ' +
        missing.map(function (id) { return desired[id].title; }).join(', ') +
        '. ' + draftMessages.missing_after : ''));
    };

    api.startDraft = function () {
      if (draftReady) return;
      draftReady = true;
      if (draft && !restoringCart) {
        var setup = document.querySelector('cb-kauf-v5-setup');
        if (setup && typeof setup.restore === 'function') setup.restore(draft.vehicle);
        api.remember();
        api.checkDraft();
      }
    };

    api.money = function (cents) {
      var value = Math.round(Number(cents) || 0) / 100;
      return (
        value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
      );
    };

    /* Nur das echte Warenkorb-Formular: form.shopify-product-form trifft auch die
       Raten-Formulare aus blocks/price.liquid, die im DOM davor stehen. */
    api.form = function () {
      return (
        document.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('form.shopify-product-form:not(.payment-terms)')
      );
    };

    /* getAttribute, nicht .id: HTMLFormElement überschreibt eingebaute Eigenschaften mit
       gleichnamigen Feldern — form.id liefert den hidden <input name="id">. */
    api.formId = function () {
      var form = api.form();
      return form ? form.getAttribute('id') : null;
    };

    api.atc = function () {
      return document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
    };

    /* `image` ist das Aufmacherbild des aktuellen Modells. Es steht im Zustand und nicht im
       Markup der Bestelluebersicht, weil die Uebersicht ausserhalb von `main` liegt und beim
       Modellwechsel nicht mitgetauscht wird — ohne den Vertrag zeigte sie weiter das alte
       Geraet. */
    api.setBase = function (title, price, image) {
      base = {
        title: String(title || ''),
        price: Math.round(Number(price) || 0),
        image: image ? String(image) : '',
      };
      api.emit();
    };

    api.setVehicle = function (value) {
      var next = value ? String(value) : '';
      var changed = next !== vehicle;
      vehicle = next;
      if (changed && draftReady) api.remember();
      api.emit();
    };

    api.limit = function (entry) {
      if (entry.kind === 'toggle') return 1;
      var max = Math.round(Number(entry.max) || 0);
      return max > 0 ? max : 10;
    };

    /* Eine Karte meldet sich an. Doppelte Variant-IDs gewinnt die erste Karte — sonst
       schrieben zwei Karten dasselbe versteckte Feld gegeneinander. */
    api.register = function (entry) {
      if (!entry || !entry.id || byId[entry.id]) return;
      entry.qty = Math.round(Number(entry.qty) || 0);
      var savedItem = desired[entry.id];
      if (savedItem && savedItem.qty <= api.limit(entry)) entry.qty = savedItem.qty;
      entry.price = Math.round(Number(entry.price) || 0);
      byId[entry.id] = entry;
      entries.push(entry);
      api.sync(entry);
      if (typeof entry.render === 'function') entry.render(entry.qty);
      api.emit();
    };

    api.unregister = function (id) {
      var entry = byId[id];
      if (!entry) return;
      delete byId[id];
      var at = entries.indexOf(entry);
      if (at !== -1) entries.splice(at, 1);
      api.emit();
    };

    /* Warenkorb-Anbindung: genau ein verstecktes Feld je gewählter Position,
       Format wie in blocks/addon-picker.liquid, damit der dortige
       formdata-Listener es unverändert an /cart/add hängt. */
    api.sync = function (entry) {
      var form = api.form();
      if (!form) return;
      var input = form.querySelector('[data-addon-input="' + entry.id + '"]');
      if (entry.qty > 0) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'addon_json';
          input.setAttribute('data-addon-input', entry.id);
          form.appendChild(input);
        }
        input.value = JSON.stringify({ id: entry.id, quantity: entry.qty });
      } else if (input) {
        input.remove();
      }
    };

    api.syncAll = function () {
      entries.forEach(api.sync);
    };

    /* Vor dem Modellwechsel: Registrierung leeren und die versteckten Felder mitnehmen. Ohne
       das blockierten die alten Variant-IDs die Anmeldung der neuen Karten, und ein Zubehör des
       alten Modells bliebe im Warenkorb-Formular stehen. */
    api.reset = function () {
      var form = api.form();
      entries.forEach(function (entry) {
        var input = form && form.querySelector('[data-addon-input="' + entry.id + '"]');
        if (input) input.remove();
      });
      document.querySelectorAll('[data-addon-input]').forEach(function (input) {
        input.remove();
      });
      entries = [];
      byId = {};
    };

    api.set = function (id, qty) {
      var entry = byId[id];
      if (!entry) return;
      var next = Math.round(Number(qty) || 0);
      if (next < 0) next = 0;
      var max = api.limit(entry);
      if (next > max) next = max;
      if (next === entry.qty) return;
      entry.qty = next;
      if (next) desired[id] = { id: String(id), qty: next, title: entry.title || '' };
      else delete desired[id];
      api.remember();
      api.checkDraft();
      api.sync(entry);
      if (typeof entry.render === 'function') entry.render(next);
      api.emit();
    };

    api.step = function (id, delta) {
      var entry = byId[id];
      if (!entry) return;
      api.set(id, entry.qty + (Math.round(Number(delta)) || 0));
    };

    api.remove = function (id) {
      api.set(id, 0);
    };

    api.get = function (id) {
      var entry = byId[id];
      return entry ? entry.qty : 0;
    };

    /* Der Zustand nach Vertrag. `savings` ist auf der Produktseite immer 0:
       Messepreise und Streichpreise gibt es nur im Konfigurator. */
    api.getState = function () {
      var items = [];
      var total = base.price;
      entries.forEach(function (entry) {
        if (!entry.qty) return;
        items.push({
          id: entry.id,
          title: entry.title,
          shortTitle: entry.shortTitle || entry.title,
          image: entry.image || '',
          imageLarge: entry.imageLarge || entry.image || '',
          description: entry.description || '',
          price: entry.price,
          qty: entry.qty,
          kind: entry.kind,
          max: api.limit(entry),
        });
        total += entry.price * entry.qty;
      });
      return {
        base: { title: base.title, price: base.price, image: base.image },
        items: items,
        total: total,
        vehicle: vehicle,
        savings: 0,
      };
    };

    api.emit = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        document.dispatchEvent(new CustomEvent('cb:config-change', { detail: api.getState() }));
      });
    };

    /* ---------------------------------------------------------------- Modellwechsel *
     * Statt eines vollen Seitenaufbaus holt die Variante die Zielseite im Hintergrund,
     * schneidet deren Abschnitt `…__main` heraus und haengt ihn an Ort und Stelle ein.
     * Alles darunter — Bento, Klaviyo-Bewertungen, FAQ — bleibt unberuehrt, die
     * Scrollposition auch. Faellt irgendetwas daran aus, geht der Klick den normalen
     * Weg ueber den `href` der Karte.
     * ---------------------------------------------------------------------------- */
    api.switching = false;

    /* Der Abschnitt heisst im DOM `shopify-section-template--<Vorlagen-ID>__main` — die ID der
       JSON-Vorlage steckt mit drin, und jede Vorlage hat eine andere. Gemessen: Pro 2.0 traegt
       `template--28563688063351__main`, Lite 2.0 `template--28563688423799__main`. Ein fester
       Name kaeme also nie mit; gesucht wird nach der FORM, nicht nach der Nummer. */
    api.mainSection = function () {
      return (
        document.querySelector('#MainContent [id^="shopify-section-"][id$="__main"]') ||
        document.querySelector('[id^="shopify-section-"][id$="__main"]') ||
        document.getElementById('shopify-section-main')
      );
    };

    /* Die Vorlage steht in der Adresse, nicht im Code. Solange der Kaufbereich als
       Alternativvorlage lebt, hängt an jeder URL `?view=kauf-v5`; sobald er in
       `product.campboks-*.json` übernommen ist, hängt dort nichts mehr — und ein festes
       `view=kauf-v5` zeigte dann auf eine gelöschte Vorlage. Also zur Laufzeit lesen und nur
       durchreichen, was wirklich da ist. */
    api.currentView = function () {
      try {
        return new URLSearchParams(window.location.search).get('view') || '';
      } catch (error) {
        return '';
      }
    };

    /* Eigene Zeile, damit der Fehlerpfad im Test beobachtbar ist. */
    api.leave = function (url) {
      window.location.href = url;
    };

    /* Wartet, bis der neue Abschnitt vorzeigbar ist: Klaviyo zeichnet seine Sterne erst
       nach, und die Bilder der ersten Folie kommen aus dem Netz. Ohne dieses Warten sieht man
       genau das, was Josef gemeldet hat — leere Buttons, flackernde Sterne. Die 800 ms sind
       die Obergrenze; danach wird gezeigt, was da ist. */
    api.waitReady = function (host) {
      var deadline = 800;
      var started = Date.now();

      var starsReady = function () {
        var stars = host.querySelector(
          '.klaviyo-star-rating-widget, [id*="klaviyo_reviews_average_rating"]'
        );
        if (!stars) return true;
        return (
          (stars.textContent || '').trim().length > 0 ||
          !!stars.querySelector('svg, img, iframe')
        );
      };

      var imagesReady = function () {
        var slide = host.querySelector('slideshow-slides > *');
        if (!slide) return true;
        var images = slide.querySelectorAll('img');
        for (var i = 0; i < images.length; i += 1) {
          if (!images[i].complete) return false;
        }
        return true;
      };

      return new Promise(function (done) {
        (function poll() {
          if ((starsReady() && imagesReady()) || Date.now() - started > deadline) {
            done();
            return;
          }
          window.setTimeout(poll, 50);
        })();
      });
    };

    api.reducedMotion = function () {
      return !!(
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    };

    api.switchModel = function (options) {
      var opts = options || {};
      var fallback = opts.href || opts.url;
      var host = api.mainSection();

      if (api.switching) return;
      if (!host || !window.fetch || !window.DOMParser || !window.Promise || !fallback) {
        if (fallback) api.leave(fallback);
        return;
      }

      var targetUrl = new URL(fallback, window.location.href);
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (/^(utm_|gclid$|gbraid$|wbraid$|fbclid$|msclkid$|preview_theme_id$|_ab$|_fd$|_sc$|view$)/.test(key) && !targetUrl.searchParams.has(key)) targetUrl.searchParams.set(key, value);
      });
      targetUrl.searchParams.delete('cb_wieder');
      var pageUrl = targetUrl.pathname + targetUrl.search;
      var pageTitle = '';
      var productSections = [];

      api.remember();
      api.switching = true;
      var scrollY = window.pageYOffset;
      var previousTitle = base.title;
      var reduced = api.reducedMotion();

      /* Die Hoehe wird festgenagelt, BEVOR irgendetwas verschwindet: Der Tausch findet bei
         Opacity 0 statt, und ohne diese Klammer fiele die Seite in sich zusammen. */
      host.style.minHeight = Math.round(host.getBoundingClientRect().height) + 'px';
      host.classList.add('cb-kauf-v5-swapping');
      if (opts.card) opts.card.classList.add('cb-kauf-v5-card--loading');

      var giveUp = function () {
        host.style.minHeight = '';
        host.classList.remove('cb-kauf-v5-swapping', 'cb-kauf-v5-fade', 'cb-kauf-v5-fade--out');
        if (opts.card) opts.card.classList.remove('cb-kauf-v5-card--loading');
        api.switching = false;
        api.leave(fallback);
      };

      /* Der eigentliche Tausch — dieselbe Handlung in beiden Uebergangsarten. */
      var applySwap = function (next) {
        api.reset();
        var current = api.mainSection();
        var minHeight = current.style.minHeight;
        current.parentNode.replaceChild(next, current);
        productSections.forEach(function (pair) {
          pair.current.parentNode.replaceChild(pair.next, pair.current);
        });
        next.style.minHeight = minHeight;
        next.classList.add('cb-kauf-v5-swapping');
        window.scrollTo(0, scrollY);

        try {
          window.history.pushState({ cbKaufV5: true }, '', pageUrl);
          api.pushed = true;
        } catch (error) {
          /* Manche Browser verbieten pushState in Sonderfaellen — dann eben ohne. */
        }
        if (pageTitle) {
          document.title = pageTitle;
        } else if (opts.title) {
          document.title =
            previousTitle && document.title.indexOf(previousTitle) !== -1
              ? document.title.replace(previousTitle, opts.title)
              : opts.title;
        }

        document.dispatchEvent(new CustomEvent('cb:main-replaced'));
        api.syncAll();
        api.emit();
        return next;
      };

      var settle = function (next) {
        next.classList.remove('cb-kauf-v5-swapping', 'cb-kauf-v5-vt');
        next.classList.remove('cb-kauf-v5-fade--out');
        next.style.minHeight = '';
        next.style.opacity = '';
        api.switching = false;
        if (!restoringCart) { api.remember(); api.checkDraft(); }
        window.setTimeout(function () {
          next.classList.remove('cb-kauf-v5-fade', 'cb-kauf-v5-fade--in');
        }, 250);
      };

      /* IMMER die ganze Zielseite, nie der schnelle Weg ueber `section_id`.
         Pro 2.0 und Lite 2.0 liegen in verschiedenen Vorlagen (`template_suffix`
         `campboks-pro-2026` bzw. `campboks-lite-2026`) — jeder Wechsel ist damit
         vorlagenuebergreifend, und genau dort ist der schnelle Weg grundsaetzlich falsch:
         Die Section Rendering API antwortet auf JEDE im Theme vorhandene Section-ID mit
         200 und rendert dabei das Markup der ANGEFRAGTEN Vorlage mit den Daten der
         Zielseite. Der Rueckfall auf die Vollseite wurde deshalb nie erreicht, und der
         Pruefstein `cb-kauf-v5-models` bestand jede Antwort. Sichtbar wurde das nur nicht,
         weil beide `main` heute strukturell gleichwertig sind — sobald sie auseinander
         laufen, zeigte der Wechsel still die Struktur der QUELLE mit den Daten des Ziels,
         und ein Reload veraenderte die Seite. Aus der Vollseite geschnitten kommt
         garantiert die Struktur des Ziels; nachweisbar an der Section-ID danach. */
      window
        .fetch(pageUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          /* Die Abschnitts-ID der Zielvorlage ist eine andere — gesucht wird deshalb nach
             der Form, nicht nach der Nummer. */
          var found =
            parsed.querySelector('#MainContent [id^="shopify-section-"][id$="__main"]') ||
            parsed.querySelector('[id^="shopify-section-"][id$="__main"]');
          /* Ein 200 ohne die Kaufspalte waere schlimmer als ein Fehler: Die Seite saehe
             danach aus wie die Agenturseite, ohne dass irgendwo etwas meldete. */
          if (!found || !found.querySelector('cb-kauf-v5-models')) {
            throw new Error('Antwort ohne V5-Kaufspalte');
          }
          if (document.querySelector('#MainContent .cb-pp-features')) {
            var sectionPairs = [
              ['pp_features'],
              ['section_tyExWQ', 'section_BWTFg7'],
              ['section_ekGnYJ', 'section_UCe9gg'],
              ['hero_Dw38fP', 'hero_PcLeaW'],
              ['tab_groups_bHGtTk', 'tab_groups_6HVTad'],
            ];
            productSections = sectionPairs.map(function (suffixes) {
              var selector = suffixes.map(function (suffix) {
                return '#MainContent [id$="__' + suffix + '"]';
              }).join(',');
              var currentSection = document.querySelector(selector);
              var nextSection = parsed.querySelector(selector);
              if (!currentSection || !nextSection) {
                throw new Error('Antwort ohne modellspezifische Produktinformationen');
              }
              return { current: currentSection, next: nextSection };
            });
          }
          pageTitle = parsed.title || '';
          return found;
        })
        .then(function (next) {

          /* Weg 1: Der Browser kann Ansichtsuebergaenge. Der alte Stand bleibt als Bild
             stehen, bis der neue fertig ist — es gibt keinen Zwischenzustand zu sehen. */
          if (!reduced && typeof document.startViewTransition === 'function') {
            host.classList.add('cb-kauf-v5-vt');
            var swapped = null;
            var transition = document.startViewTransition(function () {
              swapped = applySwap(next);
              swapped.classList.add('cb-kauf-v5-vt');
              return api.waitReady(swapped);
            });
            transition.finished
              .catch(function () {})
              .then(function () {
                var landed = swapped || api.mainSection();
                /* Gleicher Grund wie unten: ohne Abschnitt bliebe die Spalte ausgeblendet. */
                if (!landed) return giveUp(new Error('Kein Abschnitt nach dem Uebergang'));
                settle(landed);
              });
            return;
          }

          /* Weg 2: von Hand ausblenden, im Dunkeln tauschen, erst wenn alles steht wieder
             aufblenden. Bei `prefers-reduced-motion` ohne Uebergang, aber mit demselben
             Warten — das Flackern ist kein Geschmacksthema. */
          host.classList.add('cb-kauf-v5-fade');
          if (!reduced) {
            /* Erzwungenes Auslesen, damit der Uebergang von der aktuellen Opacity startet. */
            void host.offsetHeight;
          }
          host.classList.add('cb-kauf-v5-fade--out');

          /* Der Koerper laeuft aus einem Timer, das aeussere `.catch(giveUp)` erreicht ihn also
             nicht mehr. Ohne eigenen Riegel bliebe `host` bei einem Fehler hier auf
             `opacity: 0` und `pointer-events: none` stehen und `api.switching` auf `true` —
             Galerie und Kaufspalte unsichtbar und totgeklickt, ohne Meldung, nur ein Reload
             hilft. Und dieser Weg ist nicht der Sonderfall: In Firefox gibt es kein
             `startViewTransition`, und bei `prefers-reduced-motion` nimmt ihn auch Chrome. */
          window.setTimeout(
            function () {
              try {
                var swapped = applySwap(next);
                swapped.classList.add('cb-kauf-v5-fade', 'cb-kauf-v5-fade--out');
                api.waitReady(swapped).then(
                  function () {
                    swapped.classList.add('cb-kauf-v5-fade--in');
                    settle(swapped);
                  },
                  function (error) {
                    giveUp(error);
                  }
                );
              } catch (error) {
                giveUp(error);
              }
            },
            reduced ? 0 : 160
          );
        })
        .catch(giveUp);
    };

    /* Zurueck im Verlauf: neu laden statt den Tausch rueckwaerts nachzubauen. Der Aufwand
       stuende in keinem Verhaeltnis, und ein halb zurueckgesetzter Zustand waere schlimmer
       als eine Zehntelsekunde Ladezeit. */
    window.addEventListener('popstate', function () {
      if (api.pushed) window.location.reload();
    });

    window.CbKaufV5 = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.startDraft, { once: true });
    else window.setTimeout(api.startDraft, 0);

    /* Der Vertrag mit sections/cb-kauf-bar.liquid. */
    window.CbKauf = {
      getState: function () {
        return api.getState();
      },
      step: function (id, delta) {
        api.step(id, delta);
      },
      remove: function (id) {
        api.remove(id);
      },
    };

    /* Blöcke, die vor dieser Datei geladen wurden, warten in der Schlange. */
    var queue = window.CbKaufV5Queue || [];
    while (queue.length) {
      var waiting = queue.shift();
      if (waiting && typeof waiting.cbAttach === 'function') waiting.cbAttach(api);
    }
    window.CbKaufV5Queue = queue;

    /* blocks/addon-picker.liquid ruft updateTotalPrice() aus toggleAddon(). Die Karten der
       Agentur sind auf diesem Template unsichtbar, geklickt werden sie also nicht — ein
       leerer Platzhalter kostet nichts und verhindert einen ReferenceError, falls doch. */
    if (typeof window.updateTotalPrice !== 'function') {
      window.updateTotalPrice = function () {};
    }

    /* Das Produktformular steht im DOM hinter der Kaufspalte; beim ersten Anmelden kann es
       fehlen. Deshalb nach dem Aufbau noch einmal alle Felder schreiben. */
    document.addEventListener('DOMContentLoaded', function () {
      api.syncAll();
      api.emit();
    });
    window.addEventListener('load', function () {
      api.syncAll();
      api.emit();
    });
  })();

  (function () {
    if (customElements.get('cb-kauf-v5-stage')) return;

    class CbKaufV5Stage extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.badge = this.querySelector('[data-cb-v5-badge]');
        this.badgePrice = this.querySelector('[data-cb-v5-badge-price]');

        if (window.CbKaufV5) this.cbAttach(window.CbKaufV5);
        else (window.CbKaufV5Queue = window.CbKaufV5Queue || []).push(this);

        /* Der Kreis folgt dem Zustand, nicht dem Server: Nach einem Modellwechsel steht der
           Preis des neuen Modells darin, ohne dass die Bühne selbst neu geladen wird. */
        this.onConfig = this.paint.bind(this);
        document.addEventListener('cb:config-change', this.onConfig);

        /* Die Kaufspalte wird beim Modellwechsel ausgetauscht — mit ihr die Galerie und damit
           der Ort, an dem der Kreis hing. Der Knoten selbst überlebt, er muss nur zurück. */
        this.onReplaced = this.remount.bind(this);
        document.addEventListener('cb:main-replaced', this.onReplaced);

        this.onResize = this.measure.bind(this);
        window.addEventListener('resize', this.onResize, { passive: true });

        this.tries = 0;
        this.mount();
        this.measure();
      }

      cbAttach(api) {
        api.setBase(this.dataset.baseTitle || '', this.dataset.basePrice || 0);
      }

      paint(event) {
        var api = window.CbKaufV5;
        var state = (event && event.detail) || (api && api.getState());
        if (!api || !state || !this.badgePrice) return;
        var text = api.money(state.base.price);
        if (this.badgePrice.textContent !== text) this.badgePrice.textContent = text;
      }

      remount() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.mountTimer) window.clearTimeout(this.mountTimer);
        this.tries = 0;
        this.mount();
        this.measure();
      }

      /* Headerhöhe und Miniaturenleiste für den Höhendeckel der Galerie. Die Werte hängen nicht
         voneinander ab: Die Thumbnails sind 72 px breit und bekommen ihre Höhe aus dem
         Seitenverhältnis, nicht aus der Folienhöhe. Eine Messung reicht also. */
      measure() {
        /* `cb-nav-v4` zuerst: Die alte Header-Section ist seit dem Navbar-Strang `disabled`,
           ihre Selektoren trafen deshalb nichts. Der Notwert 72 + 16 ergab zufaellig genau die
           88 px der neuen Leiste — der Fehler blieb dadurch unsichtbar, haette aber zugeschlagen,
           sobald jemand die Leistenhoehe im Editor verstellt. */
        var header =
          document.querySelector('cb-nav-v4') ||
          document.querySelector('#header-component') ||
          document.querySelector('.header-section') ||
          document.querySelector('header');
        var headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
        /* Die Leiste wechselt ihre Beschriftung bei laufender Konfiguration und kann dabei die
           Hoehe aendern; einmal messen reicht dafuer nicht. */
        if (header && !this.headerWatch && typeof ResizeObserver === 'function') {
          this.headerWatch = new ResizeObserver(
            function () {
              this.measure();
            }.bind(this)
          );
          this.headerWatch.observe(header);
        }
        document.documentElement.style.setProperty(
          '--cb-kauf-v5-header',
          (headerHeight || 72) + 16 + 'px'
        );

        var thumbs = document.querySelector(
          '#MainContent slideshow-controls[thumbnails], ' +
            '#MainContent .slideshow-controls__thumbnails-container'
        );
        var thumbsHeight = thumbs ? Math.round(thumbs.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty(
          '--cb-kauf-v5-thumbs',
          (thumbsHeight || 96) + 'px'
        );
      }

      disconnectedCallback() {
        if (this.mountTimer) window.clearTimeout(this.mountTimer);
        if (this.observer) this.observer.disconnect();
        if (this.headerWatch) {
          this.headerWatch.disconnect();
          this.headerWatch = null;
        }
        if (this.onConfig) document.removeEventListener('cb:config-change', this.onConfig);
        if (this.onReplaced) document.removeEventListener('cb:main-replaced', this.onReplaced);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.badge && this.badge.parentElement !== this) {
          this.badge.parentElement.removeChild(this.badge);
          this.appendChild(this.badge);
          this.badge.hidden = true;
        }
        delete this.dataset.cbInit;
      }

      /* Einhängen in die Theme-Galerie. Der Container ist derselbe, in dem die Pfeile sitzen —
         er ist bereits `position: relative` und zählt keine Folien. */
      mount() {
        if (!this.badge) return;
        var selector = this.dataset.mount || '#MainContent media-gallery slideshow-container';
        var host = document.querySelector(selector);
        if (!host) {
          this.tries += 1;
          if (this.tries > 40) return;
          this.mountTimer = window.setTimeout(this.mount.bind(this), 100);
          return;
        }
        if (window.getComputedStyle(host).position === 'static') {
          host.style.position = 'relative';
        }
        host.appendChild(this.badge);
        this.badge.hidden = false;
        this.watchFirstSlide(host);
      }

      /* Der Kreis gehört auf das Aufmacherbild. Ab der zweiten Aufnahme verdeckt er das Motiv,
         darum blendet er aus, sobald die erste Folie weitgehend aus dem Ausschnitt ist.
         Findet sich keine Folie, bleibt er stehen — sichtbar ist besser als weg. */
      watchFirstSlide(host) {
        if (this.dataset.firstOnly !== '1') return;
        var scroller = host.querySelector('slideshow-slides');
        var first = scroller && scroller.firstElementChild;
        if (!scroller || !first || !window.IntersectionObserver) return;
        var badge = this.badge;
        this.observer = new IntersectionObserver(
          function (records) {
            records.forEach(function (record) {
              badge.classList.toggle('cb-kauf-v5-badge--away', record.intersectionRatio < 0.5);
            });
          },
          { root: scroller, threshold: [0, 0.5, 1] }
        );
        this.observer.observe(first);
      }
    }

    customElements.define('cb-kauf-v5-stage', CbKaufV5Stage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-nav-v4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
     * Drei Lebenszyklen des Hauptknopfs.
     *
     *   leer       nichts geschehen       "Jetzt konfigurieren"
     *   begonnen   Konfigurator benutzt   "Konfiguration abschließen"
     *   voll       Warenkorb befuellt     "Kauf abschliessen"
     *
     * "voll" kennt der Server (cart.item_count), "begonnen" nicht. Letzteres haengt
     * an einem gespeicherten Entwurf, der angelegt wird, sobald jemand im Kaufformular
     * etwas aendert. Ein blosser Seitenbesuch zaehlt bewusst nicht: wer drei Sekunden
     * auf der Produktseite war, hat nichts konfiguriert, und "fortsetzen" waere gelogen.
     */
    var EV = 'cart:update';

    function marke(link) {
      return window.CbConfigDraft ? window.CbConfigDraft.read() : null;
    }

    function begonnen(link) { return !!marke(link); }

    function sync(root, count) {
      var link = root.querySelector('[data-cb-cfg]');
      if (!link) return;
      var badge = link.querySelector('[data-cb-cfg-badge]');
      var label = link.querySelector('[data-cb-cfg-label]');
      var sr = link.querySelector('[data-cb-cfg-sr]');

      link.setAttribute('data-letzte-anzahl', String(count));

      var zustand;
      if (count > 0) {
        /* Befuellter Warenkorb schlaegt alles - auch auf der Produktseite. Ohne
           Warenkorb-Symbol in der Leiste ist dieser Knopf der einzige Weg dorthin. */
        zustand = 'voll';
      } else if (link.hasAttribute('data-auf-produkt')) {
        zustand = 'beratung';
      } else {
        zustand = begonnen(link) ? 'begonnen' : 'leer';
      }

      var text = zustand === 'begonnen' ? window.CbConfigDraft.messages.resume : link.getAttribute('data-label-' + zustand);
      if (label && text) label.textContent = text;
      var ziel = link.getAttribute('data-href-' + zustand);
      /* Bei begonnener Konfiguration zurueck auf die Seite, auf der sie begonnen
         wurde - sonst schickt "fortsetzen" den Kunden auf ein anderes Modell. */
      if (zustand === 'begonnen') {
        var gemerkt = marke(link);
        if (gemerkt && gemerkt.p) {
          var resumeUrl = new URL(gemerkt.p, window.location.origin);
          new URLSearchParams(window.location.search).forEach(function (value, key) {
            if (/^(utm_|gclid$|gbraid$|wbraid$|fbclid$|msclkid$|preview_theme_id$|_ab$|_fd$|_sc$)/.test(key)) resumeUrl.searchParams.set(key, value);
          });
          ziel = resumeUrl.pathname + resumeUrl.search;
        }
      }
      if (ziel) link.setAttribute('href', ziel);

      link.setAttribute('data-zustand', zustand);
      link.classList.toggle('cb-nav-v4__btn--ghost', zustand === 'beratung');
      link.classList.toggle('cb-nav-v4__btn--primary', zustand !== 'beratung');

      /* Beide Zustaende tragen einen Punkt, "begonnen" einen kleineren: dort
         liegt noch nichts im Warenkorb, der Klick stellt den gespeicherten
         Entwurf wieder her. data-has-config bleibt dem vollen Zustand vorbehalten,
         daran haengt die Zaehlvariante des Badges. */
      if (zustand === 'voll') {
        link.setAttribute('data-has-config', '');
        if (badge && badge.getAttribute('data-cb-badge-style') === 'anzahl') {
          badge.textContent = String(count);
        }
      } else {
        link.removeAttribute('data-has-config');
      }

      if (sr) {
        if (zustand === 'voll') sr.textContent = link.getAttribute('data-sr-voll') || '';
        else if (zustand === 'begonnen') sr.textContent = text;
        else sr.textContent = '';
      }
    }

    function init(root) {
      var link = root.querySelector('[data-cb-cfg]');
      if (!link) return;
      var start = Number(link.getAttribute('data-cart-count')) || 0;
      sync(root, start);

    }

    /*
     * cart:update ist ein Ereignis dieses Dokuments und erreicht andere Tabs
     * nicht. Wer in Tab B etwas ablegt und nach A zurueckwechselt, saehe dort
     * sonst den alten Stand - und mit ihm eine falsche Beschriftung. Deshalb
     * beim Zurueckkehren zum Tab und beim Zurueck aus dem Verlauf einmal
     * nachfragen. pageshow deckt den Back-Forward-Cache ab, bei dem die Seite
     * ohne neues Laden wieder erscheint und auch die Merkfrist neu zu pruefen ist.
     */
    var cartRead = 0;
    function abgleichen() {
      if (document.visibilityState === 'hidden') return;
      var request = ++cartRead;
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js',
            { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (korb) {
          if (request !== cartRead) return;
          var n = korb && typeof korb.item_count === 'number' ? korb.item_count : null;
          if (n === null) return;
          document.querySelectorAll('.cb-nav-v4').forEach(function (root) { sync(root, n); });
        })
        .catch(function () {});
    }

    document.addEventListener('cb:draft-change', function () {
      document.querySelectorAll('.cb-nav-v4').forEach(function (root) {
        var link = root.querySelector('[data-cb-cfg]');
        sync(root, Number(link && link.getAttribute('data-letzte-anzahl')) || 0);
      });
    });
    document.addEventListener(EV, abgleichen);
    document.addEventListener('visibilitychange', abgleichen);
    window.addEventListener('storage', function (event) { if (event.key === null || event.key === 'cbConfigDraftV1') abgleichen(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) abgleichen(); });

    document.querySelectorAll('.cb-nav-v4').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) {
        e.target.querySelectorAll('.cb-nav-v4').forEach(init);
      }
    });
  })();

  class CbNavV4 extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit === '1') return;
      this.dataset.cbInit = '1';

      this.pill = this.querySelector('[data-cb-pill]');
      this.bar = this.querySelector('.cb-nav-v4__bar');
      this.drawer = this.querySelector('[data-cb-drawer]');
      this.burger = this.querySelector('[data-cb-burger]');
      this.triggers = Array.from(this.querySelectorAll('[data-cb-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-cb-panel]'));
      this.openId = null;
      this.hoverTimer = null;
      this.leaveTimer = null;
      this.lockedScroll = false;

      this.finePointer =
        window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.bindObserver();
      this.bindTriggers();
      this.bindDrawer();
      this.bindGlobal();
      this.bindStufe();
    }

    /* ---- Platzstufe: passt das Menue neben Logo und Aktionen? -----
       Stufen siehe CSS "Platzstufen". Gemessen wird mit Werten, die nicht
       animiert werden: Summe der Menuepunkte plus Ziel-Abstand aus der
       Variable (column-gap selbst laeuft beim Scrollen per Transition). */
    bindStufe() {
      this.navEl = this.querySelector('.cb-nav-v4__nav');
      this.liste = this.querySelector('.cb-nav-v4__list');
      if (!this.pill || !this.navEl || !this.liste || typeof ResizeObserver === 'undefined') {
        this.dataset.cbStufe = '0';
        return;
      }
      this.desktop = window.matchMedia('(min-width: 990px)');
      // Nicht im Observer-Callback messen (ResizeObserver-Schleife), sondern im naechsten Frame.
      this.planeStufe = () => {
        if (this.stufeRaf) return;
        this.stufeRaf = window.requestAnimationFrame(() => {
          this.stufeRaf = 0;
          this.stufe();
        });
      };
      this.stufeRO = new ResizeObserver(this.planeStufe);
      this.stufeRO.observe(this.pill);
      const actions = this.querySelector('.cb-nav-v4__actions');
      if (actions) this.stufeRO.observe(actions);
      // Satoshi kommt spaet; mit Ersatzschrift waeren die Punkte anders breit.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.planeStufe);
      this.stufe();
    }

    setzeStufe(n) {
      this.classList.toggle('is-eng', n === 1 || n === 2);
      this.classList.toggle('is-klein', n === 2);
      this.classList.toggle('is-burger', n === 3);
      this.dataset.cbStufe = String(n);
    }

    menuePasst() {
      const punkte = this.liste.children;
      let summe = 0;
      for (let i = 0; i < punkte.length; i++) summe += punkte[i].offsetWidth;
      const abstand = parseFloat(getComputedStyle(this).getPropertyValue('--cb-nav-v4-nav-gap')) || 0;
      return summe + abstand * Math.max(0, punkte.length - 1) <= this.navEl.clientWidth + 0.5;
    }

    stufe() {
      // Offenes Panel sperrt das Scrollen, die Seite wird um die Scrollleiste
      // breiter - dort nicht neu entscheiden, sonst kippt die Stufe hin und her.
      if (this.drawer && this.drawer.classList.contains('is-open')) return;
      const vorher = this.dataset.cbStufe;
      let n = 0;
      // Unter 990px ist das Menue ausgeblendet (Breite 0): keine Messung.
      if (this.desktop.matches) {
        for (; n < 3; n++) {
          this.setzeStufe(n);
          if (this.menuePasst()) break;
        }
      }
      this.setzeStufe(n);
      if (n === 3 && vorher !== '3') this.closePanels();
    }

    /* ---- Zustand: kompakt / luftig ------------------------------- */
    bindObserver() {
      const sentinel = this.querySelector('.cb-nav-v4__sentinel');
      if (!sentinel || typeof IntersectionObserver === 'undefined') {
        // Ohne IntersectionObserver bleibt es dauerhaft beim kompakten Zustand.
        this.classList.add('is-compact');
        this.markReady();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('is-compact', !entry.isIntersecting);
          });
          this.markReady();
        },
        { root: null, threshold: 0 }
      );
      this.observer.observe(sentinel);
    }

    markReady() {
      if (this.isReady) return;
      this.isReady = true;
      // Doppeltes rAF: der erste Zustand wird ohne Uebergang gemalt,
      // erst danach werden die Transitions eingeschaltet. Verhindert das
      // Anlaufflackern, wenn die Seite bereits gescrollt geladen wird.
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.classList.add('is-ready');
        });
      });
    }

    /* ---- Mega-Menue --------------------------------------------- */
    panelFor(id) {
      return this.panels.find((p) => p.dataset.cbPanel === id) || null;
    }

    triggerFor(id) {
      return this.triggers.find((t) => t.dataset.cbTrigger === id) || null;
    }

    openPanel(id) {
      if (this.openId === id) return;
      this.closePanels();
      const panel = this.panelFor(id);
      const trigger = this.triggerFor(id);
      if (!panel || !trigger) return;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      this.openId = id;
    }

    closePanels(returnFocus) {
      if (this.openId === null) return;
      const trigger = this.triggerFor(this.openId);
      const panel = this.panelFor(this.openId);
      if (panel) panel.classList.remove('is-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) trigger.focus();
      }
      this.openId = null;
    }

    bindTriggers() {
      this.triggers.forEach((trigger) => {
        const id = trigger.dataset.cbTrigger;

        // Enter/Space loesen bei <button> automatisch click aus.
        trigger.addEventListener('click', () => {
          if (this.openId === id) this.closePanels();
          else this.openPanel(id);
        });

        if (!this.finePointer) return;

        const item = trigger.closest('.cb-nav-v4__item');
        if (!item) return;
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          window.clearTimeout(this.leaveTimer);
          window.clearTimeout(this.hoverTimer);
          this.hoverTimer = window.setTimeout(() => this.openPanel(id), 90);
        });
        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          window.clearTimeout(this.hoverTimer);
          window.clearTimeout(this.leaveTimer);
          this.leaveTimer = window.setTimeout(() => {
            // Nur schliessen, wenn der Zeiger die ganze Leiste verlassen hat.
            if (this.bar && this.bar.matches(':hover')) return;
            this.closePanels();
          }, 180);
        });
      });
    }

    /* ---- Mobiles Panel ------------------------------------------ */
    lockScroll(on) {
      const root = document.documentElement;
      if (on) {
        if (root.hasAttribute('scroll-lock')) return;
        root.setAttribute('scroll-lock', '');
        this.lockedScroll = true;
      } else if (this.lockedScroll) {
        root.removeAttribute('scroll-lock');
        this.lockedScroll = false;
      }
    }

    openDrawer() {
      if (!this.drawer || !this.burger) return;
      this.closePanels();
      this.drawer.classList.add('is-open');
      this.burger.setAttribute('aria-expanded', 'true');
      this.lockScroll(true);
    }

    closeDrawer(returnFocus) {
      if (!this.drawer || !this.burger) return;
      if (!this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.burger.setAttribute('aria-expanded', 'false');
      this.lockScroll(false);
      if (returnFocus) this.burger.focus();
      // Waehrend das Panel offen war, wurde die Stufe nicht neu bestimmt.
      if (this.planeStufe) this.planeStufe();
    }

    bindDrawer() {
      if (!this.drawer || !this.burger) return;
      this.burger.addEventListener('click', () => {
        if (this.drawer.classList.contains('is-open')) this.closeDrawer();
        else this.openDrawer();
      });
      // Mobil: Auswahl eines Links schliesst das Panel wieder.
      this.drawer.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) this.closeDrawer();
      });
    }

    /* ---- Global -------------------------------------------------- */
    bindGlobal() {
      this.onKeydown = (event) => {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        if (this.openId !== null) {
          this.closePanels(true);
        } else if (this.drawer && this.drawer.classList.contains('is-open')) {
          this.closeDrawer(true);
        }
      };
      this.onDocClick = (event) => {
        if (this.contains(event.target)) return;
        this.closePanels();
        this.closeDrawer();
      };
      this.onFocusIn = (event) => {
        if (!this.contains(event.target)) {
          this.closePanels();
          this.closeDrawer();
          return;
        }
        // Fokus innerhalb der Leiste, aber ausserhalb des offenen Panels:
        // dann gehoert das Panel geschlossen (Tab aus dem Panel heraus).
        if (this.openId === null) return;
        const panel = this.panelFor(this.openId);
        const trigger = this.triggerFor(this.openId);
        if (panel && panel.contains(event.target)) return;
        if (trigger && trigger === event.target) return;
        this.closePanels();
      };
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('focusin', this.onFocusIn);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.stufeRO) this.stufeRO.disconnect();
      if (this.stufeRaf) window.cancelAnimationFrame(this.stufeRaf);
      window.clearTimeout(this.hoverTimer);
      window.clearTimeout(this.leaveTimer);
      if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
      if (this.onFocusIn) document.removeEventListener('focusin', this.onFocusIn);
      this.lockScroll(false);
      this.dataset.cbInit = '';
    }
  }

  if (!customElements.get('cb-nav-v4')) customElements.define('cb-nav-v4', CbNavV4);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-reviews"] && !Shopify.designMode) return;
  try {
    
  /*
    Laufband: übernimmt die Karten des Klaviyo-Karussells in ein eigenes Marquee mit Lauf-Physik.
    Sucht das Karussell nur innerhalb der eigenen Section, damit mehrere Instanzen pro Seite gehen.
    - läuft gleichmäßig und endlos (Karten werden für die nahtlose Schleife dupliziert)
    - Maus darüber: stoppt; Ziehen mit Maus/Finger mit Schwung; horizontales Mausrad verschiebt direkt
  */
  class CbReviewsLoop extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';
      this.root = this.closest('.cb-reviews');
      if (!this.root) return;
      this.seconds = parseFloat(this.dataset.seconds || '0');
      this.showArrows = this.dataset.arrows === 'true';
      const started = Date.now();
      if (this.tryInit()) return;
      this.cbTimer = window.setInterval(() => {
        if (this.tryInit() || Date.now() - started > 30000) window.clearInterval(this.cbTimer);
      }, 400);
    }

    tryInit() {
      const wrapper = this.root.querySelector('[id="klaviyo-reviews-carousel-wrapper"]');
      const swiperEl = wrapper && wrapper.querySelector('.swiper');
      const inst = swiperEl && swiperEl.swiper;
      if (!wrapper || !inst || !inst.slides || inst.slides.length < 2) return false;
      if (wrapper.classList.contains('cb-reviews--has-marquee')) return true;
      try {
        this.buildMarquee(wrapper, swiperEl, inst);
      } catch (e) {
        /* Klaviyo-Markup hat sich geändert: Karussell bleibt wie von der App geliefert. */
      }
      return true;
    }

    buildMarquee(wrapper, swiperEl, inst) {
      const originals = Array.from(swiperEl.querySelectorAll('.swiper-slide')).filter(
        (s) => !s.classList.contains('swiper-slide-duplicate')
      );
      if (originals.length < 2) return;

      // Swiper abschalten, Original-Karten (mit ihren Klick-Handlern) in die eigene Spur übernehmen.
      try {
        inst.destroy(true, true);
      } catch (e) {
        /* ignorieren */
      }

      const viewport = document.createElement('div');
      viewport.className = 'cb-reviews__marquee';
      const track = document.createElement('div');
      track.className = 'cb-reviews__track';
      originals.forEach((s) => {
        s.removeAttribute('style');
        track.appendChild(s);
      });
      // Zweite Hälfte als Kopie für die nahtlose Schleife.
      originals.forEach((s) => {
        const c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button, [tabindex]').forEach((n) => n.setAttribute('tabindex', '-1'));
        track.appendChild(c);
      });
      viewport.appendChild(track);
      wrapper.classList.add('cb-reviews--has-marquee');
      wrapper.appendChild(viewport);

      const arrowSvg = (dir) =>
        dir === 'prev'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
      let prevBtn = null;
      let nextBtn = null;
      if (this.showArrows) {
        prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'cb-reviews__arrow cb-reviews__arrow--prev';
        prevBtn.setAttribute('aria-label', this.dataset.labelPrev || '');
        prevBtn.innerHTML = arrowSvg('prev');
        nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'cb-reviews__arrow cb-reviews__arrow--next';
        nextBtn.setAttribute('aria-label', this.dataset.labelNext || '');
        nextBtn.innerHTML = arrowSvg('next');
        wrapper.appendChild(prevBtn);
        wrapper.appendChild(nextBtn);
      }

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cardCount = originals.length;
      const secondsPerCard = reduce ? 0 : this.seconds;

      let rafId = 0;
      let lastTime = performance.now();
      let x = 0;
      let v = 0;
      let mode = 'auto'; // auto | drag | momentum
      let hoverPaused = false;
      let dragStartClientX = 0;
      let dragStartTrackX = 0;
      let lastMoveTime = 0;
      let lastMoveClientX = 0;
      let dragVelocity = 0;
      let dragMoved = false;

      const halfWidth = () => track.scrollWidth / 2;
      const baselineV = () => {
        if (secondsPerCard <= 0) return 0;
        return -halfWidth() / (secondsPerCard * cardCount * 1000);
      };
      const normalize = () => {
        const half = halfWidth();
        if (half <= 0) return;
        while (x <= -half) x += half;
        while (x > 0) x -= half;
      };
      const apply = () => {
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      };

      const tick = (now) => {
        const dt = Math.min(now - lastTime, 64);
        lastTime = now;
        if (mode === 'momentum') {
          const target = hoverPaused ? 0 : baselineV();
          const decay = Math.pow(0.94, dt / 16.67);
          v = target + (v - target) * decay;
          x += v * dt;
          normalize();
          apply();
          if (Math.abs(v - target) < Math.abs(target) * 0.05 + 0.0005) {
            v = target;
            mode = 'auto';
          }
        } else if (mode === 'auto' && !hoverPaused) {
          v = baselineV();
          if (v !== 0) {
            x += v * dt;
            normalize();
            apply();
          }
        }
        rafId = window.requestAnimationFrame(tick);
      };
      rafId = window.requestAnimationFrame(tick);

      const startDrag = (clientX) => {
        mode = 'drag';
        dragMoved = false;
        dragStartClientX = clientX;
        dragStartTrackX = x;
        lastMoveTime = performance.now();
        lastMoveClientX = clientX;
        dragVelocity = 0;
        viewport.classList.add('is-dragging');
      };
      const moveDrag = (clientX) => {
        if (mode !== 'drag') return;
        const now = performance.now();
        const dt = now - lastMoveTime;
        if (dt > 0) {
          const instantV = (clientX - lastMoveClientX) / dt;
          dragVelocity = dragVelocity * 0.3 + instantV * 0.7;
        }
        lastMoveTime = now;
        lastMoveClientX = clientX;
        if (Math.abs(clientX - dragStartClientX) > 4) dragMoved = true;
        x = dragStartTrackX + (clientX - dragStartClientX);
        normalize();
        apply();
      };
      const endDrag = () => {
        if (mode !== 'drag') return;
        const now = performance.now();
        if (now - lastMoveTime > 100) dragVelocity = 0;
        v = dragVelocity;
        mode = 'momentum';
        viewport.classList.remove('is-dragging');
      };

      // Touch: horizontal ziehen; vertikal bleibt Seitenscroll (touch-action: pan-y).
      viewport.addEventListener('touchstart', (e) => startDrag(e.touches[0].clientX), { passive: true });
      viewport.addEventListener('touchmove', (e) => moveDrag(e.touches[0].clientX), { passive: true });
      viewport.addEventListener('touchend', endDrag, { passive: true });
      viewport.addEventListener('touchcancel', endDrag, { passive: true });

      const canHover = window.matchMedia('(hover: hover)').matches;
      if (canHover) {
        viewport.addEventListener('mouseenter', () => {
          hoverPaused = true;
        });
        viewport.addEventListener('mouseleave', () => {
          hoverPaused = false;
        });
        viewport.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          startDrag(e.clientX);
          e.preventDefault();
        });
        window.addEventListener('mousemove', (e) => moveDrag(e.clientX));
        window.addEventListener('mouseup', endDrag);
        // Klick nach einem Zieh-Vorgang nicht als Klick auf die Karte werten.
        viewport.addEventListener(
          'click',
          (e) => {
            if (dragMoved) {
              e.stopPropagation();
              e.preventDefault();
              dragMoved = false;
            }
          },
          true
        );
        viewport.addEventListener(
          'wheel',
          (e) => {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            x -= e.deltaX;
            normalize();
            apply();
            e.preventDefault();
          },
          { passive: false }
        );
      }

      const nudge = (dir) => {
        const card = originals[0].getBoundingClientRect().width + 20;
        v = (dir * card) / 450;
        mode = 'momentum';
      };
      if (prevBtn) prevBtn.addEventListener('click', () => nudge(1));
      if (nextBtn) nextBtn.addEventListener('click', () => nudge(-1));

      // Außerhalb des Viewports keine Arbeit.
      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((en) => en.isIntersecting);
          if (!visible && rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = 0;
          } else if (visible && !rafId) {
            lastTime = performance.now();
            rafId = window.requestAnimationFrame(tick);
          }
        },
        { threshold: 0.05 }
      );
      io.observe(viewport);
      apply();
    }

    disconnectedCallback() {
      if (this.cbTimer) window.clearInterval(this.cbTimer);
    }
  }
  if (!customElements.get('cb-reviews-loop')) customElements.define('cb-reviews-loop', CbReviewsLoop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-bento"] && !Shopify.designMode) return;
  try {
    
  // Sanftes Scrollen zu Ankern innerhalb der Bento-Sections (nur hier, nicht global).
  (function () {
    if (window.cbSfV6BentoAnchors) return;
    window.cbSfV6BentoAnchors = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('.cb-sf-v6-bento a[href^="#"]') : null;
      if (!trigger) return;

      var hash = trigger.getAttribute('href');
      if (!hash || hash === '#' || hash.length < 2) return;

      var target = document.getElementById(hash.slice(1));
      if (!target) return;

      event.preventDefault();

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(null, '', window.location.pathname + window.location.search + hash);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-hero-morph"] && !Shopify.designMode) return;
  try {
    
  class CbSfV6HeroMorph extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';

      const after = this.querySelector('[data-cb-after]');
      const stage = this.querySelector('[data-cb-stage]');
      const content = this.querySelector('[data-cb-stagger]');
      if (content) requestAnimationFrame(() => content.classList.add('is-in'));
      if (!after) return;

      const reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const setState = (on, duration) => {
        after.style.setProperty('--cb-hm-dur', duration + 'ms');
        after.classList.toggle('is-on', on);
      };


      // Ablauf: leer halten → Crossfade + eingebaut halten → zurueck → Schleife.
      const STEPS = [
        { on: false, dur: 1000, hold: 1200 },
        { on: true, dur: 1400, hold: 3000 },
      ];

      let index = 0;
      let timer = null;
      let manual = false;
      let visible = false;
      let started = false;

      const clear = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      };

      const run = () => {
        clear();
        if (manual || !visible) return;
        const step = STEPS[index % STEPS.length];
        setState(step.on, started ? step.dur : 0);
        started = true;
        timer = setTimeout(() => {
          index += 1;
          run();
        }, step.dur + step.hold);
      };

      // Tipp/Klick oder Enter/Leertaste auf der Bildbuehne: umschalten und Schleife anhalten.
      const flip = () => {
        manual = true;
        clear();
        setState(!after.classList.contains('is-on'), reduce ? 0 : 400);
      };

      if (stage) {
        stage.addEventListener('click', flip);
        stage.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            flip();
          } else if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            flip();
          }
        });
      }

      if (reduce) {
        setState(true, 0);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        visible = true;
        run();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            visible = entry.isIntersecting;
            if (visible) run();
            else clear();
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(this);
    }
  }

  if (!customElements.get('cb-sf-v6-hero-morph')) {
    customElements.define('cb-sf-v6-hero-morph', CbSfV6HeroMorph);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-steps"] && !Shopify.designMode) return;
  try {
    
  class CbSfV6Steps extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';
      const items = Array.from(this.querySelectorAll('[data-cb-step]'));
      const frames = Array.from(this.querySelectorAll('[data-cb-step-media]'));
      if (!items.length) return;

      if (frames.length && 'IntersectionObserver' in window) {
        const setActive = (index) => {
          frames.forEach((f) => {
            f.classList.toggle('is-active', f.getAttribute('data-cb-step-media') === String(index));
          });
        };

        const visible = new Map();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              visible.set(entry.target.getAttribute('data-cb-step'), entry.intersectionRatio);
            });
            let best = null;
            let bestRatio = 0;
            visible.forEach((ratio, key) => {
              if (ratio > bestRatio) {
                bestRatio = ratio;
                best = key;
              }
            });
            if (best !== null && bestRatio > 0) setActive(best);
          },
          { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '-20% 0px -20% 0px' }
        );
        items.forEach((item) => observer.observe(item));
        this.cbObserver = observer;
      }

      // Linie durch die Punkte (mobil und Desktop), Füllung scrollgebunden bis zur Lesezeile (50 % wie
      // auf Über uns). Punkte über der Lesezeile sind erledigt, der letzte davon aktiv.
      const track = this.querySelector('[data-cb-step-track]');
      const fill = this.querySelector('[data-cb-step-fill]');
      const dots = items.map((item) => item.querySelector('.cb-sf-v6-steps__dot'));
      if (!track || !fill || dots.some((d) => !d)) return;

      // Die Füllung folgt dem Scrollwert weich nach (exponentiell, ~90 ms), damit grobe Scroll-Schritte
      // am Handy nicht als Ruckeln sichtbar werden. Anker über clientHeight statt innerHeight: springt
      // nicht mit der ein- und ausfahrenden Adressleiste.
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let ticking = false;
      let active = -1;
      let railGeometry = '';
      let target = 0;
      let shown = null;
      let last = 0;
      const render = (now) => {
        this.cbRaf = 0;
        const dt = last ? Math.min(64, now - last) : 16;
        last = now;
        if (shown === null || reduced.matches) shown = target;
        else shown += (target - shown) * (1 - Math.exp(-dt / 90));
        if (Math.abs(target - shown) < 0.0005) shown = target;
        fill.style.setProperty('--cb-sf-v6-progress', shown.toFixed(4));
        if (shown !== target) this.cbRaf = requestAnimationFrame(render);
        else last = 0;
      };
      const update = () => {
        ticking = false;
        const trackTop = track.getBoundingClientRect().top;
        const centers = dots.map((d) => {
          const r = d.getBoundingClientRect();
          return r.top + r.height / 2;
        });
        const first = centers[0];
        const span = centers[centers.length - 1] - first;
        // Linienlage nur schreiben, wenn sie sich ändert (Bilder nachgeladen, Resize), nicht bei jedem Frame.
        const geometry = `${(first - trackTop).toFixed(1)}|${Math.max(0, span).toFixed(1)}`;
        if (geometry !== railGeometry) {
          railGeometry = geometry;
          track.style.setProperty('--cb-sf-v6-rail-top', `${(first - trackTop).toFixed(1)}px`);
          track.style.setProperty('--cb-sf-v6-rail-height', `${Math.max(0, span).toFixed(1)}px`);
        }

        const anchor = document.documentElement.clientHeight * 0.5;
        target = Math.min(1, Math.max(0, (anchor - first) / Math.max(1, span)));
        if (!this.cbRaf) this.cbRaf = requestAnimationFrame(render);

        let next = 0;
        centers.forEach((c, i) => {
          if (c <= anchor) next = i;
        });
        if (next === active) return;
        active = next;
        items.forEach((item, i) => {
          item.classList.toggle('is-active', i === active);
          item.classList.toggle('is-passed', i < active);
        });
      };
      this.cbOnScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      };
      window.addEventListener('scroll', this.cbOnScroll, { passive: true });
      window.addEventListener('resize', this.cbOnScroll, { passive: true });
      update();
    }

    disconnectedCallback() {
      if (this.cbObserver) this.cbObserver.disconnect();
      if (this.cbRaf) cancelAnimationFrame(this.cbRaf);
      this.cbRaf = 0;
      if (this.cbOnScroll) {
        window.removeEventListener('scroll', this.cbOnScroll);
        window.removeEventListener('resize', this.cbOnScroll);
      }
      delete this.dataset.cbInit;
    }
  }
  if (!customElements.get('cb-sf-v6-steps')) customElements.define('cb-sf-v6-steps', CbSfV6Steps);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-sticky"] && !Shopify.designMode) return;
  try {
    
  // Aktuell verbundene, "gewinnende" Instanz (siehe Doppel-Schutz in connectedCallback). Modulweit,
  // nicht pro Instanz: der dokumentweite Klick-Listener unten wird nur EINMAL registriert (dieser
  // Javascript-Block läuft unabhängig von der Zahl der Section-Instanzen nur einmal pro Seite) und
  // bedient über diese Variable immer die zuletzt verbundene Instanz. Ohne das bliebe im Theme-
  // Editor bei jedem shopify:section:load ein weiterer Listener der alten, längst entfernten
  // Instanz aktiv: er würde weiter preventDefault()/cb_rueckruf_start auf einem Element auslösen,
  // das gar nicht mehr im DOM hängt – sichtbar passiert dann nichts.
  let cbSfBeratungActive = null;

  // sessionStorage/localStorage können im privaten Modus oder per Einstellung gesperrt sein.
  // Fallback im Speicher: ohne Storage gelten die Merker wenigstens für diese Seite.
  const cbSfMem = {};
  const cbSfStore = (area, key, value) => {
    const memKey = area + ':' + key;
    try {
      const store = window[area];
      if (value === undefined) return store.getItem(key) ?? cbSfMem[memKey] ?? null;
      store.setItem(key, value);
    } catch (err) {
      if (value === undefined) return cbSfMem[memKey] ?? null;
    }
    cbSfMem[memKey] = value;
    return null;
  };

  // Teaser-Regeln. Ein Signal allein reicht nicht: erst Mindest-Verweildauer, dann Kaufinteresse,
  // auch mitten im Scrollen. Höchstens einmal pro Sitzung.
  const CB_PEEK = {
    minActive: 5000, // sichtbare Verweildauer auf der Seite, bevor überhaupt etwas passiert
    minActiveRepeat: 5000, // ab der 2. Seite der Sitzung: Interesse ist schon belegt
    depth: 0.45, // Scrolltiefe (Unterkante des Fensters / Seitenhöhe)
    depthScreens: 2, // oder so viele Bildschirmhöhen gescrollt: mobil ist die Seite ~25 Bildschirme lang
    backtrackFrom: 0.6, // Zurückscrollen nach tiefem Scrollen = Vergleichen/Zögern
    backtrackBy: 0.15,
    longActive: 45000, // lange Lesezeit mit Interaktion genügt auch ohne Tiefe
    exitMin: 8000, // Desktop: Maus verlässt das Fenster nach oben
    duration: 10000, // danach wieder Pille (pausiert bei Hover/Fokus)
    collapseScreens: 1, // erst nach einer Bildschirmhöhe Scrollen klappt der Teaser zu (Puffer)
    settle: 400, // Puffer zählt erst, wenn das laufende Wischen (iOS-Schwung) so lange ruht …
    settleMax: 2000, // … spätestens aber so lange nach dem Aufgehen
    cooldownDays: 7, // nach Klick auf X
  };

  // Fängt Klicks auf Links zur alten Beratungsseite dokumentweit ab (Capture-Phase, vor allen
  // anderen Handlern) und öffnet stattdessen das Rückruf-Formular der aktiven Instanz. Kein
  // Modifier-Klick (neuer Tab etc.) und nur ohne Rückruf-Möglichkeit (kein rfBtn/rfEl) lässt den
  // Link normal navigieren.
  document.addEventListener(
    'click',
    (e) => {
      if (!cbSfBeratungActive) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }
      if (!/\/pages\/kostenloser-beratungstermin\/?$/.test(url.pathname)) return;
      if (!cbSfBeratungActive.rfBtn || !cbSfBeratungActive.rfEl) return; // kein Formular verfügbar: Seite bleibt Fallback
      e.preventDefault();
      e.stopPropagation(); // verhindert, dass der Outside-Click-Handler das eben geöffnete Panel sofort wieder schließt
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cb_beratung_link_intercept' });
      document.dispatchEvent(new CustomEvent('cb:analytics', { detail: { event: 'cb_beratung_link_intercept' } }));
      cbSfBeratungActive.dispatchEvent(new CustomEvent('cb-rueckruf:request'));
    },
    true
  );

  class CbSfV6Sticky extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      // Doppel-Schutz: liegt die Section zusaetzlich in einem Seiten-Template (andere Branches),
      // gewinnt die erste Instanz in der Dokumentreihenfolge, alle weiteren blenden sich aus.
      const all = document.querySelectorAll('cb-sf-v6-sticky');
      if (all.length > 1 && all[0] !== this) {
        this.hidden = true;
        return;
      }
      this.dataset.cbInit = '1';
      cbSfBeratungActive = this;
      this.trigger = this.querySelector('[data-cb-trigger]');
      // Texte aus locales (data-cb-sticky-i18n); der t-Filter liefert HTML-escaped, textarea dekodiert.
      try {
        const i18nEl = this.querySelector('script[data-cb-sticky-i18n]');
        this.cbTexts = JSON.parse(i18nEl ? i18nEl.textContent : '{}') || {};
      } catch (err) {
        this.cbTexts = {};
      }
      this.panel = this.querySelector('[data-cb-panel]');
      this.hoursEl = this.querySelector('[data-cb-hours]');
      this.shell = this.querySelector('.cb-sf-v6-sticky__shell');
      this.labelEl = this.querySelector('[data-cb-label]');
      this.callEl = this.querySelector('[data-cb-call]');
      this.aiBtn = this.querySelector('[data-cb-ai]');
      this.rfBtn = this.querySelector('[data-cb-rueckruf]');
      this.rfEl = document.getElementById('cb-rueckruf-' + this.id.replace('cb-sf-v6-sticky-', ''));
      this.optionsEl = this.querySelector('[data-cb-options]');
      if (!this.rfEl && this.rfBtn) {
        this.rfBtn.remove();
        this.rfBtn = null;
      }
      this.chatEl = this.dataset.aiChat ? document.getElementById(this.dataset.aiChat) : null;
      if (!this.chatEl && this.aiBtn) {
        this.aiBtn.remove();
        this.aiBtn = null;
      }
      this.peekEl = this.querySelector('[data-cb-peek]');
      this.peekX = this.querySelector('[data-cb-peek-x]');
      this.peekCall = this.querySelector('[data-cb-peek-act="call"]');
      // Chips ohne Ziel entfernen (KI-Chat aus, Rückruf-Formular fehlt)
      if (!this.aiBtn) this.querySelector('[data-cb-peek-act="ai"]')?.remove();
      if (!this.rfBtn) this.querySelector('[data-cb-peek-act="rueckruf"]')?.remove();
      if (!this.callEl && this.peekCall) {
        this.peekCall.remove();
        this.peekCall = null;
      }
      this.applyState();
      // Zustand alle 60 s neu prüfen (Geschäftszeiten können während des Besuchs enden).
      this.cbStateTimer = window.setInterval(() => this.applyState(), 60000);
      this.bindScroll();
      this.bindInteractions();
      this.bindPeek();
      // Links auf die alte Beratungsseite (/pages/kostenloser-beratungstermin) werden dokumentweit
      // einmalig (modulweiter Listener oben, siehe cbSfBeratungActive) abgefangen: Klick öffnet
      // stattdessen dieses Panel mit dem Rückruf-Formular. Die Seite bleibt als Fallback ohne JS
      // bestehen, ihr href in den 17 Theme-Dateien wird nicht angefasst.
      // ?rueckruf=1 bzw. #rueckruf beim Laden: Panel + Formular einmalig öffnen (kommt aus dem
      // globalen Rewrite in snippets/vehicle-check-utm.liquid für Seiten ohne diese Section).
      this.openFromInitParam();
    }

    viennaNow() {
      try {
        const fmt = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Vienna',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        });
        const parts = {};
        fmt.formatToParts(new Date()).forEach((p) => {
          parts[p.type] = p.value;
        });
        const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return { day: dayMap[parts.weekday], hour: parseInt(parts.hour, 10) % 24, minute: parseInt(parts.minute, 10) };
      } catch (e) {
        const d = new Date();
        return { day: d.getDay(), hour: d.getHours(), minute: d.getMinutes() };
      }
    }

    isOpenNow() {
      // Test-Schalter: ?cb_test=open bzw. ?cb_test=closed erzwingt den Zustand (nur für Vorschau/Abnahme).
      try {
        const test = new URLSearchParams(window.location.search).get('cb_test');
        if (test === 'open') return true;
        if (test === 'closed') return false;
      } catch (e) {
        /* ignorieren */
      }
      if (this.dataset.forceClosed === 'true') return false;
      const days = (this.dataset.days || '')
        .split(',')
        .filter(Boolean)
        .map((n) => parseInt(n, 10));
      const open = parseFloat(this.dataset.open || '9');
      const close = parseFloat(this.dataset.close || '16');
      const now = this.viennaNow();
      const t = now.hour + now.minute / 60;
      return days.includes(now.day) && t >= open && t < close;
    }

    cbT(key, vars) {
      const area = document.createElement('textarea');
      area.innerHTML = (this.cbTexts && this.cbTexts[key]) || '';
      return Object.keys(vars || {}).reduce((acc, k) => acc.split(k).join(String(vars[k])), area.value);
    }

    applyState() {
      const open = this.isOpenNow();
      if (this.trigger) this.trigger.hidden = false;
      this.classList.toggle('is-after-hours', !open);
      if (this.callEl) this.callEl.hidden = !open;
      if (this.peekCall) this.peekCall.hidden = !open;
      if (this.labelEl) {
        const label = open ? this.dataset.labelOpen : this.dataset.labelClosed;
        if (label && this.labelEl.textContent !== label) this.labelEl.textContent = label;
      }
      if (this.hoursEl) {
        const closeH = parseFloat(this.dataset.close || '16');
        const custom = this.dataset.hoursText || '';
        const text = custom || (open ? this.cbT('hoursUntil', { '%H%': Math.floor(closeH) }) : '');
        this.hoursEl.textContent = text;
        this.hoursEl.hidden = !text;
      }
      window.requestAnimationFrame(() => {
        if (this.classList.contains('is-open') || this.classList.contains('is-peek')) return;
        this.style.setProperty('--cb-w-collapsed', 'auto');
        const w = this.shell ? this.shell.getBoundingClientRect().width : 0;
        if (w) this.style.setProperty('--cb-w-collapsed', Math.ceil(w) + 'px');
      });
    }

    open() {
      if (!this.trigger || this.trigger.hidden) return;
      this.endPeek('open');
      cbSfStore('sessionStorage', 'cbStickyUsed', '1');
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      const first = this.panel && this.panel.querySelector('[data-cb-options] a:not([hidden]), [data-cb-options] button:not([hidden])');
      if (first) window.setTimeout(() => first.focus({ preventScroll: true }), 200);
    }

    close() {
      this.endPeek('close');
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      this.closeRueckruf(false);
    }

    // Geschäftszeiten vom Dienst übernehmen (hours: {open:'09:00', close:'16:00', days:[1..7] ISO}).
    applyHours(hours) {
      if (!hours || !hours.open || !hours.close) return;
      const toH = (c) => {
        const [h, m] = String(c).split(':').map((n) => parseInt(n, 10));
        return h + (m || 0) / 60;
      };
      this.dataset.open = String(toH(hours.open));
      this.dataset.close = String(toH(hours.close));
      if (Array.isArray(hours.days)) this.dataset.days = hours.days.map((d) => (d === 7 ? 0 : d)).join(',') + ',';
      this.applyState();
    }

    loadRueckruf() {
      if (this.cbRfReady) return this.cbRfReady;
      const el = this.rfEl;
      const addOnce = (tag, attrs) =>
        new Promise((resolve, reject) => {
          const node = document.createElement(tag);
          Object.keys(attrs).forEach((k) => node.setAttribute(k, attrs[k]));
          node.addEventListener('load', resolve, { once: true });
          node.addEventListener('error', reject, { once: true });
          document.head.appendChild(node);
        });
      const ready = customElements.get('cb-rueckruf');
      this.cbRfReady = Promise.all([ready ? Promise.resolve() : addOnce('link', { rel: 'stylesheet', href: el.dataset.css }), ready ? Promise.resolve() : addOnce('script', { src: el.dataset.js, defer: '' })])
        .then(() => customElements.whenDefined('cb-rueckruf'))
        .catch((err) => {
          this.cbRfReady = null;
          throw err;
        });
      return this.cbRfReady;
    }

    openRueckruf() {
      this.rfBtn.setAttribute('aria-busy', 'true');
      this.loadRueckruf()
        .then(() => {
          this.classList.add('is-form');
          this.rfBtn.setAttribute('aria-expanded', 'true');
          this.rfEl.open(this.rfBtn);
        })
        .catch(() => {
          // Laden fehlgeschlagen: Telefonnummer anzeigen statt nichts zu tun.
          const sub = this.rfBtn.querySelector('.cb-sf-v6-sticky__option-sub');
          if (sub) sub.textContent = this.cbT('unavailable', { '%P%': this.callEl ? this.callEl.dataset.phone : '' });
        })
        .finally(() => this.rfBtn.removeAttribute('aria-busy'));
    }

    closeRueckruf(focus = true) {
      if (!this.classList.contains('is-form')) return;
      this.classList.remove('is-form');
      if (this.rfEl) this.rfEl.hidden = true;
      if (this.rfBtn) {
        this.rfBtn.setAttribute('aria-expanded', 'false');
        if (focus) this.rfBtn.focus({ preventScroll: true });
      }
    }

    // ?rueckruf=1 oder #rueckruf in der aktuellen URL: Panel + Formular einmal öffnen, danach den
    // Parameter/Hash per replaceState entfernen (kein Reload, kein erneutes Öffnen bei Zurück-Navigation).
    openFromInitParam() {
      let hasParam = false;
      let u;
      try {
        u = new URL(window.location.href);
        hasParam = u.searchParams.has('rueckruf') || window.location.hash === '#rueckruf';
      } catch (err) {
        return;
      }
      if (!hasParam) return;
      window.requestAnimationFrame(() => {
        if (!this.rfBtn || !this.rfEl) return;
        this.dispatchEvent(new CustomEvent('cb-rueckruf:request'));
        try {
          const clean = new URL(window.location.href);
          clean.searchParams.delete('rueckruf');
          const hash = clean.hash === '#rueckruf' ? '' : clean.hash;
          window.history.replaceState(null, '', clean.pathname + clean.search + hash);
        } catch (err) {
          /* ignorieren */
        }
      });
    }

    bindRueckruf() {
      const warm = () => {
        this.loadRueckruf().catch(() => {});
      };
      this.rfBtn.addEventListener('pointerenter', warm, { once: true });
      this.rfBtn.addEventListener('focus', warm, { once: true });
      this.rfBtn.addEventListener('click', () => this.openRueckruf());
      this.rfEl.addEventListener('cb-rueckruf:close', () => this.closeRueckruf());
      this.rfEl.addEventListener('cb-rueckruf:hours', (e) => this.applyHours(e.detail));
      // Von außen (z. B. KI-Chat) öffnen
      this.addEventListener('cb-rueckruf:request', () => {
        this.classList.add('is-visible');
        this.open();
        this.openRueckruf();
      });
    }

    bindInteractions() {
      if (this.trigger) {
        this.trigger.addEventListener('click', () => {
          if (this.classList.contains('is-open')) {
            this.close();
            return;
          }
          const fromPeek = this.classList.contains('is-peek');
          this.open();
          // Nur das Aufklappen zählen, nicht das Zuklappen über denselben Knopf.
          document.dispatchEvent(new CustomEvent('cb:analytics', {
            detail: { event: 'cta_clicked', properties: { cta_id: 'beraten_lassen', placement: fromPeek ? 'sticky_peek' : 'sticky' } }
          }));
        });
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
          if (this.trigger) this.trigger.focus();
        } else if (e.key === 'Escape') this.endPeek('escape');
      });
      document.addEventListener('click', (e) => {
        if (!this.classList.contains('is-open')) return;
        // Klicks im KI-Chat (z. B. „Rückruf vereinbaren") lösen cb-rueckruf:request aus, das
        // synchron is-open setzt, bevor derselbe Klick per Bubbling hier ankommt. Ohne diese
        // Ausnahme schließt der Outside-Click-Handler das gerade erst geöffnete Panel wieder,
        // sobald openRueckruf() asynchron is-form nachträgt.
        if (this.chatEl && this.chatEl.contains(e.target)) return;
        if (!this.contains(e.target)) this.close();
      });

      const push = (name) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name });
        this.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      };
      const call = this.querySelector('[data-cb-call]');
      const coarse = window.matchMedia('(pointer: coarse)').matches;
      if (call) {
        call.addEventListener('click', (e) => {
          push('cb_call_click');
          if (coarse) return; // Handy: tel:-Link startet den Anruf
          // Desktop: Nummer kopieren statt ins Leere zu springen.
          e.preventDefault();
          const num = call.dataset.phone || '';
          const sub = call.querySelector('[data-cb-call-sub]');
          const done = () => {
            if (!sub) return;
            const prev = sub.textContent;
            sub.textContent = this.cbT('copied', { '%P%': num });
            window.setTimeout(() => {
              sub.textContent = prev;
            }, 2500);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(num).then(done, done);
          else done();
        });
      }
      if (this.aiBtn) this.bindChat();
      if (this.rfBtn) this.bindRueckruf();
    }

    // KI-Chat: CSS und JS erst bei Bedarf laden (Vorwärmen bei Hover/Fokus, sonst beim Klick).
    loadChat() {
      if (this.cbChatReady) return this.cbChatReady;
      const chat = this.chatEl;
      const addOnce = (tag, attrs) =>
        new Promise((resolve, reject) => {
          const el = document.createElement(tag);
          Object.keys(attrs).forEach((k) => el.setAttribute(k, attrs[k]));
          el.addEventListener('load', resolve, { once: true });
          el.addEventListener('error', reject, { once: true });
          document.head.appendChild(el);
        });
      const css = customElements.get('cb-ki-chat')
        ? Promise.resolve()
        : addOnce('link', { rel: 'stylesheet', href: chat.dataset.css });
      const js = customElements.get('cb-ki-chat')
        ? Promise.resolve()
        : addOnce('script', { src: chat.dataset.js, defer: '' });
      this.cbChatReady = Promise.all([css, js])
        .then(() => customElements.whenDefined('cb-ki-chat'))
        .catch((err) => {
          this.cbChatReady = null;
          throw err;
        });
      return this.cbChatReady;
    }

    bindChat() {
      const warm = () => {
        this.loadChat().catch(() => {});
      };
      this.aiBtn.addEventListener('pointerenter', warm, { once: true });
      this.aiBtn.addEventListener('focus', warm, { once: true });
      this.aiBtn.addEventListener('click', () => {
        this.aiBtn.setAttribute('aria-busy', 'true');
        this.loadChat()
          .then(() => {
            this.close();
            this.classList.add('is-chat-open', 'is-visible');
            this.chatEl.open(this.trigger);
          })
          .catch(() => {
            // Laden fehlgeschlagen: Telefonnummer anzeigen statt nichts zu tun.
            const sub = this.aiBtn.querySelector('.cb-sf-v6-sticky__option-sub');
            if (sub) sub.textContent = this.cbT('unavailable', { '%P%': this.callEl ? this.callEl.dataset.phone : '' });
          })
          .finally(() => this.aiBtn.removeAttribute('aria-busy'));
      });
      this.chatEl.addEventListener('cb-ki-chat:close', () => {
        this.classList.remove('is-chat-open');
        this.classList.add('is-visible');
      });
    }

    // Teaser: Pille geht bei Kaufinteresse kurz zur kleinen Karte auf (Regeln: CB_PEEK oben).
    bindPeek() {
      if (!this.peekEl) return;
      this.peekEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-cb-peek-act]');
        if (btn) this.peekAction(btn.dataset.cbPeekAct);
      });
      if (this.peekX) {
        this.peekX.addEventListener('click', () => {
          // Fokus nur zurückgeben, wenn das X ihn hatte (Tastatur). Beim Tippen auf iOS hätte das
          // programmatische focus() den Fokusring auf der Pille sichtbar gemacht.
          const hadFocus = document.activeElement === this.peekX;
          cbSfStore('localStorage', 'cbPeekDismissed', String(Date.now()));
          this.endPeek('dismiss');
          if (hadFocus && this.trigger) this.trigger.focus({ preventScroll: true });
        });
      }
      // Während Hover/Fokus nicht automatisch zuklappen
      const hold = () => window.clearTimeout(this.cbPeekTimer);
      const resume = () => {
        if (!this.classList.contains('is-peek') || this.contains(document.activeElement)) return;
        window.clearTimeout(this.cbPeekTimer);
        this.cbPeekTimer = window.setTimeout(() => this.endPeek('timeout'), 4000);
      };
      this.shell.addEventListener('pointerenter', hold);
      this.shell.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', hold);
      this.addEventListener('focusout', () => window.setTimeout(resume, 0));

      // Test-Schalter für Vorschau/Abnahme: ?cb_peek=1 zeigt den Teaser sofort, ohne Sperren.
      let forced = false;
      try {
        forced = new URLSearchParams(window.location.search).get('cb_peek') === '1';
      } catch (err) {
        /* ignorieren */
      }
      if (forced) {
        window.setTimeout(() => {
          this.classList.add('is-visible');
          this.startPeek('test');
        }, 800);
        return;
      }
      if (window.Shopify && window.Shopify.designMode) return;
      if (this.peekBlocked()) return;

      const pages = parseInt(cbSfStore('sessionStorage', 'cbPeekPages') || '0', 10) + 1;
      cbSfStore('sessionStorage', 'cbPeekPages', String(pages));
      const minActive = pages > 1 ? CB_PEEK.minActiveRepeat : CB_PEEK.minActive;
      let active = 0;
      let interacted = false;
      let maxDepth = 0;
      let maxY = 0;
      let backtrack = false;
      const depthNow = () => {
        const h = document.documentElement.scrollHeight || 1;
        return Math.min(1, (window.scrollY + window.innerHeight) / h);
      };
      const onScroll = () => {
        interacted = true;
        const d = depthNow();
        if (d > maxDepth) maxDepth = d;
        if (window.scrollY > maxY) maxY = window.scrollY;
        if (maxDepth >= CB_PEEK.backtrackFrom && d <= maxDepth - CB_PEEK.backtrackBy) backtrack = true;
        if (this.classList.contains('is-peek') && this.cbPeekSettling) {
          // Geht der Teaser mitten im Wischen auf, würde der Schwung den Puffer sofort aufbrauchen:
          // Startpunkt mitziehen, bis das Scrollen kurz ruht.
          this.cbPeekY = window.scrollY;
          window.clearTimeout(this.cbPeekSettleTimer);
          this.cbPeekSettleTimer = window.setTimeout(() => (this.cbPeekSettling = false), CB_PEEK.settle);
          if (Date.now() - this.cbPeekAt > CB_PEEK.settleMax) this.cbPeekSettling = false;
        } else if (this.classList.contains('is-peek') && Math.abs(window.scrollY - this.cbPeekY) > CB_PEEK.collapseScreens * window.innerHeight) {
          this.endPeek('scroll');
        }
      };
      const onInteract = () => {
        interacted = true;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('pointerdown', onInteract, { passive: true });
      document.addEventListener('keydown', onInteract);
      this.cbPeekOff = [
        () => window.removeEventListener('scroll', onScroll),
        () => document.removeEventListener('pointerdown', onInteract),
        () => document.removeEventListener('keydown', onInteract),
      ];

      this.cbPeekTick = window.setInterval(() => {
        if (this.cbPeekDone || this.peekBlocked()) {
          this.unbindPeek();
          return;
        }
        if (document.visibilityState !== 'visible') return;
        active += 1000;
        if (active < minActive || !interacted) return;
        let reason = null;
        if (maxDepth >= CB_PEEK.depth || maxY >= CB_PEEK.depthScreens * window.innerHeight) reason = 'depth';
        else if (backtrack) reason = 'backtrack';
        else if (active >= CB_PEEK.longActive) reason = 'time';
        if (reason) this.tryPeek(reason);
      }, 1000);

      // Desktop: Maus verlässt das Fenster nach oben (Tab schließen, zurück)
      if (window.matchMedia('(pointer: fine)').matches) {
        const onLeave = (e) => {
          if (e.relatedTarget || e.clientY > 0) return;
          if (active >= CB_PEEK.exitMin) this.tryPeek('exit');
        };
        document.addEventListener('mouseout', onLeave);
        this.cbPeekOff.push(() => document.removeEventListener('mouseout', onLeave));
      }
    }

    // Beobachter abbauen. Läuft ein Teaser noch, braucht er nur das Scrollen zum Zuklappen: das
    // übernimmt bindScroll nicht, daher bleibt der Scroll-Listener bis zum Ende des Teasers.
    unbindPeek() {
      window.clearInterval(this.cbPeekTick);
      this.cbPeekTick = null;
      if (this.classList.contains('is-peek')) return;
      (this.cbPeekOff || []).forEach((off) => off());
      this.cbPeekOff = null;
    }

    peekBlocked() {
      if (cbSfStore('sessionStorage', 'cbPeekShown') || cbSfStore('sessionStorage', 'cbStickyUsed')) return true;
      const dismissed = parseInt(cbSfStore('localStorage', 'cbPeekDismissed') || '0', 10);
      return dismissed > 0 && Date.now() - dismissed < CB_PEEK.cooldownDays * 864e5;
    }

    // Etwas anderes liegt gerade im Vordergrund (Cookie-Banner, Klaviyo-Popup, Warenkorb, Dialoge)?
    overlayVisible() {
      const nodes = document.querySelectorAll('#shopify-pc__banner, dialog[open], [role="dialog"][aria-modal="true"]');
      return Array.prototype.some.call(nodes, (el) => {
        if (this.contains(el) || (this.chatEl && this.chatEl.contains(el))) return false;
        const r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) return false;
        const cs = window.getComputedStyle(el);
        return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0.05;
      });
    }

    tryPeek(reason) {
      if (this.cbPeekDone || this.peekBlocked()) return;
      if (!this.trigger || this.trigger.hidden) return;
      if (!this.classList.contains('is-visible') && !this.hasAttribute('data-always')) return;
      if (this.classList.contains('is-open') || this.classList.contains('is-chat-open') || this.classList.contains('is-form')) return;
      const ae = document.activeElement;
      if (ae && (ae.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName))) return;
      if (this.overlayVisible()) return;
      // Per CSS ausgeblendet (z. B. Kauf-Leiste auf Produktseiten): nichts zeigen, nichts zählen
      if (!this.shell || this.shell.getBoundingClientRect().width < 1) return;
      this.startPeek(reason);
    }

    startPeek(reason) {
      if (!this.peekEl || this.classList.contains('is-open')) return;
      this.cbPeekDone = true;
      cbSfStore('sessionStorage', 'cbPeekShown', '1');
      this.cbPeekY = window.scrollY;
      this.cbPeekAt = Date.now();
      this.cbPeekSettling = true;
      window.clearTimeout(this.cbPeekSettleTimer);
      this.cbPeekSettleTimer = window.setTimeout(() => (this.cbPeekSettling = false), CB_PEEK.settle);
      this.peekEl.inert = false;
      if (this.peekX) this.peekX.hidden = false;
      this.classList.add('is-peek');
      document.dispatchEvent(new CustomEvent('cb:analytics', { detail: { event: 'cta_peek_shown', properties: { reason, placement: 'sticky' } } }));
      window.clearTimeout(this.cbPeekTimer);
      this.cbPeekTimer = window.setTimeout(() => this.endPeek('timeout'), CB_PEEK.duration);
    }

    endPeek(why) {
      if (!this.classList.contains('is-peek')) return;
      window.clearTimeout(this.cbPeekTimer);
      // Fokus aus dem Teaser holen, bevor er inert wird
      if (this.peekEl.contains(document.activeElement) || document.activeElement === this.peekX) {
        if (this.trigger) this.trigger.focus({ preventScroll: true });
      }
      this.classList.remove('is-peek');
      this.peekEl.inert = true;
      if (this.peekX) this.peekX.hidden = true;
      if (!this.cbPeekTick) this.unbindPeek(); // Teaser war der einzige Grund für die Beobachter
      if (why === 'dismiss' || why === 'timeout' || why === 'scroll') {
        document.dispatchEvent(new CustomEvent('cb:analytics', { detail: { event: 'cta_peek_closed', properties: { why } } }));
      }
    }

    peekAction(act) {
      document.dispatchEvent(new CustomEvent('cb:analytics', {
        detail: { event: 'cta_clicked', properties: { cta_id: 'peek_' + act, placement: 'sticky_peek' } }
      }));
      this.endPeek('action');
      cbSfStore('sessionStorage', 'cbStickyUsed', '1');
      if (act === 'ai' && this.aiBtn) this.aiBtn.click();
      else if (act === 'rueckruf' && this.rfBtn) this.dispatchEvent(new CustomEvent('cb-rueckruf:request'));
      else if (act === 'call' && this.callEl) {
        // Handy: direkt wählen. Desktop: Panel öffnen, dort steht die Nummer zum Kopieren.
        if (window.matchMedia('(pointer: coarse)').matches) this.callEl.click();
        else this.open();
      }
    }

    bindScroll() {
      if (this.hasAttribute('data-always')) return;
      const threshold = parseInt(this.dataset.threshold || '300', 10);
      const hideAfter = parseInt(this.dataset.hideAfter || '100', 10);
      let last = window.scrollY;
      /* tiefster Punkt seit dem letzten Runterscrollen: erst nach hideAfter px
         Hochscrollen ausblenden, damit kleines Zurückspringen (Mausrad) nicht reicht */
      let peak = last;
      let ticking = false;
      const update = () => {
        const y = window.scrollY;
        if (y > last) peak = y;
        if (this.classList.contains('is-open') || this.classList.contains('is-peek')) {
          /* geöffnet bleibt sichtbar, der Teaser klappt erst nach dem Puffer in bindPeek zu */
        } else if (y <= threshold) this.classList.remove('is-visible');
        else if (y > last) this.classList.add('is-visible');
        else if (peak - y > hideAfter) this.classList.remove('is-visible');
        if (!this.classList.contains('is-visible')) this.endPeek('hidden');
        last = y;
        ticking = false;
      };
      this.cbOnScroll = () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      };
      window.addEventListener('scroll', this.cbOnScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.cbOnScroll) window.removeEventListener('scroll', this.cbOnScroll);
      if (this.cbStateTimer) window.clearInterval(this.cbStateTimer);
      window.clearTimeout(this.cbPeekTimer);
      this.classList.remove('is-peek');
      this.unbindPeek();
      // Der modulweite Klick-Listener oben bedient nur die zuletzt verbundene Instanz; eine
      // entfernte Instanz darf nicht länger als Ziel stehen bleiben (z. B. im Theme-Editor beim
      // Neuladen der Section).
      if (cbSfBeratungActive === this) cbSfBeratungActive = null;
    }
  }
  if (!customElements.get('cb-sf-v6-sticky')) customElements.define('cb-sf-v6-sticky', CbSfV6Sticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-system-b"] && !Shopify.designMode) return;
  try {
    
  class CbSfV6SystemBVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-cb-open]');
      const closer = this.querySelector('[data-cb-close]');
      const media = this.querySelector('[data-cb-media]');
      if (!dialog || !opener || !media) return;

      opener.addEventListener('click', () => {
        const id = this.dataset.videoId;
        if (!id) return;
        media.replaceChildren();
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
        iframe.setAttribute('title', this.dataset.iframeTitle || '');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        media.appendChild(iframe);
        dialog.showModal();
        // Fokus auf den Schliessen-Button legen, sonst landet er im YouTube-iframe
        // und Escape erreicht den Dialog nicht mehr.
        if (closer) closer.focus();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cb_video_open', cb_video_id: id });
        document.dispatchEvent(new CustomEvent('cb:analytics', { detail: { event: 'cb_video_open', properties: { cb_video_id: id } } }));
      });

      if (closer) closer.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => media.replaceChildren());
    }
  }
  if (!customElements.get('cb-sf-v6-system-b-video')) customElements.define('cb-sf-v6-system-b-video', CbSfV6SystemBVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sf-v6-video"] && !Shopify.designMode) return;
  try {
    
  class CbSfV6Video extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';
      const triggers = this.querySelectorAll('[data-cb-video-trigger]');
      if (!triggers.length) return;
      const play = () => {
        if (this.dataset.cbPlaying) return;
        const id = this.dataset.videoId;
        if (!id) return;
        this.dataset.cbPlaying = '1';
        const frame = document.createElement('div');
        frame.className = 'cb-sf-v6-video__frame';
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
        iframe.setAttribute('title', this.dataset.iframeTitle || '');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        frame.appendChild(iframe);
        this.replaceChildren();
        this.appendChild(frame);
      };
      triggers.forEach((trigger) => trigger.addEventListener('click', play));
    }
  }
  if (!customElements.get('cb-sf-v6-video')) customElements.define('cb-sf-v6-video', CbSfV6Video);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-ueber-uns-timeline"] && !Shopify.designMode) return;
  try {
    
  class CbUeberUnsTimeline extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbInit) return;
      this.dataset.cbInit = '1';
      const items = Array.from(this.querySelectorAll('[data-cb-tl-step]'));
      const frames = Array.from(this.querySelectorAll('[data-cb-tl-media]'));
      const list = this.querySelector('[data-cb-tl-list]');
      const fill = this.querySelector('[data-cb-tl-fill]');
      if (!items.length) return;

      const setActive = (index) => {
        const active = Number(index);
        items.forEach((item, i) => {
          item.classList.toggle('is-active', i === active);
          item.classList.toggle('is-passed', i < active);
        });
        frames.forEach((f) => {
          const on = f.getAttribute('data-cb-tl-media') === String(index);
          f.classList.toggle('is-active', on);
          f.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      };

      if ('IntersectionObserver' in window) {
        const visible = new Map();
        this.cbObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              visible.set(entry.target.getAttribute('data-cb-tl-step'), entry.intersectionRatio);
            });
            let best = null;
            let bestRatio = 0;
            visible.forEach((ratio, key) => {
              if (ratio > bestRatio) {
                bestRatio = ratio;
                best = key;
              }
            });
            if (best !== null && bestRatio > 0) setActive(best);
          },
          { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '-35% 0px -35% 0px' }
        );
        items.forEach((item) => this.cbObserver.observe(item));
      }

      // Linie füllt sich mit dem Lesefortschritt. Die Füllung folgt dem Scrollwert weich nach
      // (exponentiell, ~90 ms), damit grobe Scroll-Schritte am Handy nicht als Ruckeln sichtbar werden.
      // Anker über clientHeight statt innerHeight: springt nicht mit der ein- und ausfahrenden Adressleiste.
      if (list && fill) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let ticking = false;
        let target = 0;
        let shown = null;
        let last = 0;
        const render = (now) => {
          this.cbRaf = 0;
          const dt = last ? Math.min(64, now - last) : 16;
          last = now;
          if (shown === null || reduced.matches) shown = target;
          else shown += (target - shown) * (1 - Math.exp(-dt / 90));
          if (Math.abs(target - shown) < 0.0005) shown = target;
          fill.style.setProperty('--cb-ueber-uns-progress', shown.toFixed(4));
          if (shown !== target) this.cbRaf = requestAnimationFrame(render);
          else last = 0;
        };
        const update = () => {
          ticking = false;
          const rect = list.getBoundingClientRect();
          const anchor = document.documentElement.clientHeight * 0.5;
          target = Math.min(1, Math.max(0, (anchor - rect.top) / Math.max(1, rect.height)));
          if (!this.cbRaf) this.cbRaf = requestAnimationFrame(render);
        };
        this.cbOnScroll = () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        };
        window.addEventListener('scroll', this.cbOnScroll, { passive: true });
        window.addEventListener('resize', this.cbOnScroll, { passive: true });
        update();
      }
    }

    disconnectedCallback() {
      if (this.cbObserver) this.cbObserver.disconnect();
      if (this.cbRaf) cancelAnimationFrame(this.cbRaf);
      this.cbRaf = 0;
      if (this.cbOnScroll) {
        window.removeEventListener('scroll', this.cbOnScroll);
        window.removeEventListener('resize', this.cbOnScroll);
      }
      delete this.dataset.cbInit;
    }
  }
  if (!customElements.get('cb-ueber-uns-timeline')) {
    customElements.define('cb-ueber-uns-timeline', CbUeberUnsTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-vgl-tabelle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-vgl-table')) {
    customElements.define('cb-vgl-table', class extends HTMLElement {
      connectedCallback() {
        /* Fallback für den Duell-Auftakt, z. B. wenn der Theme-Editor die Section neu einsetzt und das Inline-Skript nicht läuft */
        const duel = this.querySelector('[data-duel].is-armed');
        if (duel) setTimeout(() => { duel.classList.remove('is-armed'); duel.classList.add('is-go'); }, 300);
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      /* Die Namenszeile klebt direkt unter dem Seitenkopf, auch wenn dieser beim Scrollen ein- oder ausfährt. */
      update() {
        const header = document.querySelector('.cb-nav-v4__bar, #header-component');
        const top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        this.style.setProperty('--cb-vgl-top', top + 'px');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
